const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, onUnmounted, nextTick } = Vue;

let currentGeolocation = null;
const hotelCollectionDomains = [
	{ country: "United States", domain: "www.hotelcollection.com" },
	{ country: "Australia", domain: "www.hotelcollection.au" },
	{ country: "Austria", domain: "at-hotelcollection.glopalstore.com" },
	{ country: "Belgium", domain: "be-hotelcollection.glopalstore.com" },
	{ country: "Brazil", domain: "www.hotelcollectionofficial.com.br" },
	{ country: "Canada", domain: "www.hotelcollection.ca" },
	{ country: "Czech Republic", domain: "cz-hotelcollection.glopalstore.com" },
	{ country: "Denmark", domain: "dk-hotelcollection.glopalstore.com" },
	{ country: "France", domain: "www.hotelcollection.fr" },
	{ country: "Germany", domain: "www.hotelcollectionofficial.de" },
	{ country: "India", domain: "www.hotelcollection.in" },
	{ country: "Ireland", domain: "ie-hotelcollection.glopalstore.com" },
	{ country: "Italy", domain: "www.hotelcollectionofficial.it" },
	{ country: "Japan", domain: "www.hotelcollectionofficial.jp" },
	{ country: "Mexico", domain: "www.hotelcollection.mx" },
	{ country: "Netherlands", domain: "www.hotelcollectionofficial.nl" },
	{ country: "Norway", domain: "no-hotelcollection.glopalstore.com" },
	{ country: "Poland", domain: "www.hotelcollection.pl" },
	{ country: "Saudi Arabia", domain: "sa-hotelcollection.glopalstore.com" },
	{ country: "Singapore", domain: "sg-hotelcollection.glopalstore.com" },
	{ country: "South Africa", domain: "www.hotelcollection.co.za" },
	{ country: "Spain", domain: "www.hotelcollection.es" },
	{ country: "Sweden", domain: "www.hotelcollectionofficial.se" },
	{ country: "Switzerland", domain: "www.hotelcollectionofficial.ch" },
	{ country: "United Arab Emirates", domain: "www.hotelcollection.ae" },
	{ country: "United Kingdom", domain: "www.hotelcollectionofficial.uk" },
	{ country: "Taiwan", domain: "tw-hotelcollection.glopalstore.com" },
	{ country: "Åland Islands", domain: "ax-hotelcollection.glopalstore.com" },
	{ country: "Albania", domain: "al-hotelcollection.glopalstore.com" },
	{ country: "Algeria", domain: "dz-hotelcollection.glopalstore.com" },
	{ country: "Andorra", domain: "ad-hotelcollection.glopalstore.com" },
	{ country: "Argentina", domain: "ar-hotelcollection.glopalstore.com" },
	{ country: "Azerbaijan", domain: "az-hotelcollection.glopalstore.com" },
	{ country: "Bahamas", domain: "bs-hotelcollection.glopalstore.com" },
	{ country: "Bahrain", domain: "bh-hotelcollection.glopalstore.com" },
	{ country: "Barbados", domain: "bb-hotelcollection.glopalstore.com" },
	{ country: "Belarus", domain: "by-hotelcollection.glopalstore.com" },
	{ country: "Bermuda", domain: "bm-hotelcollection.glopalstore.com" },
	{ country: "Bolivia", domain: "bo-hotelcollection.glopalstore.com" },
	{
		country: "Bosnia and Herzegovina",
		domain: "ba-hotelcollection.glopalstore.com",
	},
	{ country: "Bulgaria", domain: "bg-hotelcollection.glopalstore.com" },
	{ country: "Cambodia", domain: "kh-hotelcollection.glopalstore.com" },
	{ country: "Cayman Islands", domain: "ky-hotelcollection.glopalstore.com" },
	{ country: "Chile", domain: "cl-hotelcollection.glopalstore.com" },
	{ country: "China", domain: "cn-hotelcollection.glopalstore.com" },
	{ country: "Colombia", domain: "co-hotelcollection.glopalstore.com" },
	{ country: "Costa Rica", domain: "cr-hotelcollection.glopalstore.com" },
	{ country: "Croatia", domain: "hr-hotelcollection.glopalstore.com" },
	{ country: "Cyprus", domain: "cy-hotelcollection.glopalstore.com" },
	{
		country: "Dominican Republic",
		domain: "do-hotelcollection.glopalstore.com",
	},
	{ country: "Ecuador", domain: "ec-hotelcollection.glopalstore.com" },
	{ country: "Egypt", domain: "eg-hotelcollection.glopalstore.com" },
	{ country: "Estonia", domain: "ee-hotelcollection.glopalstore.com" },
	{ country: "Faroe Islands", domain: "fo-hotelcollection.glopalstore.com" },
	{ country: "Finland", domain: "fi-hotelcollection.glopalstore.com" },
	{ country: "Georgia", domain: "ge-hotelcollection.glopalstore.com" },
	{ country: "Ghana", domain: "gh-hotelcollection.glopalstore.com" },
	{ country: "Gibraltar", domain: "gi-hotelcollection.glopalstore.com" },
	{ country: "Greece", domain: "gr-hotelcollection.glopalstore.com" },
	{ country: "Guatemala", domain: "gt-hotelcollection.glopalstore.com" },
	{ country: "Guernsey", domain: "gg-hotelcollection.glopalstore.com" },
	{ country: "Hong Kong", domain: "hk-hotelcollection.glopalstore.com" },
	{ country: "Hungary", domain: "hu-hotelcollection.glopalstore.com" },
	{ country: "Iceland", domain: "is-hotelcollection.glopalstore.com" },
	{ country: "Indonesia", domain: "id-hotelcollection.glopalstore.com" },
	{ country: "Isle of Man", domain: "im-hotelcollection.glopalstore.com" },
	{ country: "Israel", domain: "il-hotelcollection.glopalstore.com" },
	{ country: "Jamaica", domain: "jm-hotelcollection.glopalstore.com" },
	{ country: "Jersey", domain: "je-hotelcollection.glopalstore.com" },
	{ country: "Jordan", domain: "jo-hotelcollection.glopalstore.com" },
	{ country: "Kazakhstan", domain: "kz-hotelcollection.glopalstore.com" },
	{ country: "Kenya", domain: "ke-hotelcollection.glopalstore.com" },
	{ country: "Kuwait", domain: "kw-hotelcollection.glopalstore.com" },
	{ country: "Latvia", domain: "lv-hotelcollection.glopalstore.com" },
	{ country: "Liechtenstein", domain: "li-hotelcollection.glopalstore.com" },
	{ country: "Lithuania", domain: "lt-hotelcollection.glopalstore.com" },
	{ country: "Luxembourg", domain: "lu-hotelcollection.glopalstore.com" },
	{ country: "Macedonia", domain: "mk-hotelcollection.glopalstore.com" },
	{ country: "Malaysia", domain: "my-hotelcollection.glopalstore.com" },
	{ country: "Malta", domain: "mt-hotelcollection.glopalstore.com" },
	{ country: "Moldova", domain: "md-hotelcollection.glopalstore.com" },
	{ country: "Monaco", domain: "mc-hotelcollection.glopalstore.com" },
	{ country: "Mongolia", domain: "mn-hotelcollection.glopalstore.com" },
	{ country: "Montenegro", domain: "me-hotelcollection.glopalstore.com" },
	{ country: "Morocco", domain: "ma-hotelcollection.glopalstore.com" },
	{ country: "Mozambique", domain: "mz-hotelcollection.glopalstore.com" },
	{ country: "New Zealand", domain: "nz-hotelcollection.glopalstore.com" },
	{ country: "Nicaragua", domain: "ni-hotelcollection.glopalstore.com" },
	{ country: "Nigeria", domain: "ng-hotelcollection.glopalstore.com" },
	{ country: "Oman", domain: "om-hotelcollection.glopalstore.com" },
	{ country: "Panama", domain: "pa-hotelcollection.glopalstore.com" },
	{
		country: "Papua New Guinea",
		domain: "pg-hotelcollection.glopalstore.com",
	},
	{ country: "Peru", domain: "pe-hotelcollection.glopalstore.com" },
	{ country: "Philippines", domain: "ph-hotelcollection.glopalstore.com" },
	{ country: "Portugal", domain: "pt-hotelcollection.glopalstore.com" },
	{ country: "Qatar", domain: "qa-hotelcollection.glopalstore.com" },
	{ country: "Romania", domain: "ro-hotelcollection.glopalstore.com" },
	{ country: "San Marino", domain: "sm-hotelcollection.glopalstore.com" },
	{ country: "Serbia", domain: "rs-hotelcollection.glopalstore.com" },
	{ country: "Slovakia", domain: "sk-hotelcollection.glopalstore.com" },
	{ country: "Slovenia", domain: "si-hotelcollection.glopalstore.com" },
	{ country: "South Korea", domain: "kr-hotelcollection.glopalstore.com" },
	{ country: "Tanzania", domain: "tz-hotelcollection.glopalstore.com" },
	{ country: "Thailand", domain: "th-hotelcollection.glopalstore.com" },
	{
		country: "Trinidad and Tobago",
		domain: "tt-hotelcollection.glopalstore.com",
	},
	{ country: "Tunisia", domain: "tn-hotelcollection.glopalstore.com" },
	{ country: "Turkey", domain: "tr-hotelcollection.glopalstore.com" },
	{ country: "Uganda", domain: "ug-hotelcollection.glopalstore.com" },
	{ country: "Uruguay", domain: "uy-hotelcollection.glopalstore.com" },
	{ country: "Vietnam", domain: "vn-hotelcollection.glopalstore.com" },
	{ country: "Zambia", domain: "zm-hotelcollection.glopalstore.com" },
];

const urlHostname = window.location.hostname;
const countryDomainMap = hotelCollectionDomains.find((d) => d.domain === urlHostname);

const paymentOptionsApp = createApp({
	name: "PaymentOptionsApp",
	setup() {
		const paymentOptionsData = ref(paymentOptionsDataObj);
		const isLoading = ref(false);
		const AtcPayload = ref([]);
		const isSubmitting = ref(false);
		const currentActiveBlock = ref("");
		const doesSubAdnExist = ref(false);
		const addOnQty = ref(1);
		const redirectToCheckout = ref(false);
		const eventsAttachedToAtc = ref(false);
		const redirectToLp = ref(null);
		const currentMainProductVarId = ref(null);
		let variantInputEl = null;

		onBeforeMount(() => {
			const blocks = paymentOptionsData.value.blocks;
			const filteredBlocks = blocks.filter(b => shouldRenderBlock(b?.blacklist || []));
			paymentOptionsData.value.blocks = filteredBlocks;
		});

		onMounted(async () => {
			isLoading.value = true;
			let paymentBlocks = paymentOptionsData.value.blocks;
			if (paymentOptionsData.value.blocks?.length) {
				renderAdditionalTagOrPriceOnMount(paymentOptionsData.value.blocks);
			}
			
			paymentOptionsData.value.blocks = paymentBlocks.map((pb) => {
				try {
					let sellingPlanName = "every 30 days."
					if (pb.type === "multi_add_on_block" && pb.add_on_select_mode === 'multiple') {
						// for quarterly subscription
						sellingPlanName = "Delivered every 90 days."
					}
					if (pb.type === "pay_in_full" || pb.type === "product_bundle_layout" || pb.type === "multi_add_on_block") {
						pb.add_ons = pb.add_ons.map((a) => {
							if (!a.hidden) {
								a.products = a.products.map((p) => {
									if (a.additional_discount) {
										// exclusive for quarterly subscription
										p.additional_discount = Number(a.additional_discount);
									}
									p.og_selling_plan_id = getSellingPlanId(p.selling_plan_allocations, sellingPlanName);
									p.annual_selling_plan_id = getSellingPlanId(p.selling_plan_allocations, "30 days, prepaid");
									p.price_info = calculateDiscount(p);
									return p;
								});
							}
							return a;
						});
					}
					return pb;
				} catch (error) {
					console.error(error, "Error fetching OG info");
				}
			});
			
			variantInputEl = document.getElementById("pb_variant_id");
			currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
			if (!countryDomainMap) {
				await loadCurrentLocation().catch((reject) => {
					console.warn(reject, "=>", "Rebuy Geolocation took too long to respond or not loaded.");
				});
			}
			isLoading.value = false;
		});

		onBeforeMount(() => {
			document.addEventListener("variant:change", () => {
				variantInputEl = document.querySelector(".product-info__buy-buttons input[name='id']");
				currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
				if (currentActiveBlock.value === "") {
					const currentVariant = paymentOptionsData.value.main_product.variants.find(
						(v) => v.id === parseInt(currentMainProductVarId.value)
					);
					handleBlockSelect("", "ADD TO CART", false, !currentVariant.available, undefined);
					updateMainProductLinePrice(
						{
							sale_price: window.mainProductPrice.sale_price,
							discount_price: window.mainProductPrice.discount_price,
							savings: window.mainProductPrice.savings,
						},
						undefined
					);
					// not needed for HC
					// setTimeout(()=>{
					// 	updateMainProductLinePrice({ sale_price: window.mainProductPrice.sale_price, discount_price: window.mainProductPrice.discount_price, savings: window.mainProductPrice.savings }, undefined);
					// },50);
				}
			});
			reHookEventsOnAtcBtn();
		});

		function getSellingPlanId(plans = [], frequency = "") {
			let annualSellingPlanId = null;
			for (let i = 0; i < plans.length; i++) {
				let sellingPlanAllocation = plans[i];
				let sellingPlan = sellingPlanAllocation.selling_plan;

				if (
					sellingPlan.recurring_deliveries &&
					sellingPlan.name.includes("Delivered") &&
					sellingPlan.name.includes(frequency)
				) {
					annualSellingPlanId = sellingPlan.id;
					break; // exit the loop
				}
			}
			return annualSellingPlanId;
		}

		function loadCurrentLocation(attempt = 0) {
			try {
				const maxAttempts = 5;
				return new Promise((resolve, reject) => {
					if (attempt >= maxAttempts) {
						reject("Max attempts reached.");
						return;
					}

					if (
						typeof Rebuy !== "undefined" &&
						Rebuy._status === "initialized" &&
						typeof Rebuy.getGeolocation === "function"
					) {
						Rebuy.getGeolocation()
							.then((resp) => {
								currentGeolocation = resp;
								resolve(currentGeolocation);
							})
							.catch((error) => {
								reject(error);
							});
					} else {
						setTimeout(() => {
							loadCurrentLocation(attempt + 1)
								.then(resolve)
								.catch(reject);
						}, 500);
					}
				});
			} catch (error) {
				console.log(error);
			}
		}

		watch(currentActiveBlock, () => {
			AtcPayload.value = [];
		});

		watch(AtcPayload, () => {
			doesSubAdnExist.value = AtcPayload.value.some((p) => p.selling_plan);
		});

		watch(isSubmitting, () => handleATCLoading());

		function reHookEventsOnAtcBtn() {
			try {
				const mutationHandler = function (mutationsList, observer) {
					for (let mutation of mutationsList) {
						if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
							let atcBtn = document.querySelector("buy-buttons .button--add-to-cart");
							// Check if the "AddToCart" button is now in the DOM
							if (atcBtn === mutation.target && atcBtn.querySelector("div")) {
								observer.disconnect();
								//console.log('mutation running');
								let clonedAtcBtn = atcBtn.cloneNode(true);
								clonedAtcBtn.setAttribute("type", "button");
								atcBtn.parentNode.replaceChild(clonedAtcBtn, atcBtn);
								clonedAtcBtn.addEventListener("click", handleAddToCart);
								reHookEventsOnQtyBtns();
								eventsAttachedToAtc.value = true;
							}

							if (paymentOptionsData.value?.hide_default_atc) {
								document.querySelector(".product-info__buy-buttons-wrapper").style.display = "none";
								document.querySelector("product-quick-add ").style.display = "none";
							}
						}
					}
				};
				const observer = new MutationObserver(mutationHandler);
				observer.observe(document.body, { childList: true, subtree: true });
			} catch (error) {
				console.log(error);
			}
		}

		function reHookEventsOnQtyBtns() {
			let qtySelector = document.querySelector("quantity-selector.quantity-selector");
			if (qtySelector) {
				let qtySelectorBtns = qtySelector.querySelectorAll("button.quantity-selector__button");
				qtySelectorBtns[0].addEventListener("click", () => handleQtySelect("-"));
				qtySelectorBtns[1].addEventListener("click", () => handleQtySelect("+"));
				document.querySelector("quantity-selector input.quantity-selector__input").style["pointer-events"] = "none";
			}
		}

		function handleQtySelect(action) {
			if (action === "+") {
				addOnQty.value = addOnQty.value + 1;
			}

			if (action === "-") {
				addOnQty.value = addOnQty.value > 1 ? addOnQty.value + 1 : addOnQty.value - 1;
			}
		}

		function handleATCLoading() {
			let atcBtn = document.querySelector("buy-buttons .button--add-to-cart");
			if (isSubmitting.value) {
				atcBtn.setAttribute("aria-busy", true);
				atcBtn.setAttribute("disabled", true);
			} else {
				atcBtn.removeAttribute("aria-busy");
				atcBtn.removeAttribute("disabled");
			}
		}

		async function handleAddToCart() {
			const compare_at_price_property = document.getElementById("line-item-custom-property");
			const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
			if (redirectToLp.value) {
				window.location.href = redirectToLp.value;
				return;
			}
			isSubmitting.value = true;
			let properties = {};
			// getting the lineitem property from the current active payment block
			const lineItemProperty = paymentOptionsData.value.blocks.find(
				(b) => b.id === currentActiveBlock.value
			)?.line_item_property;
			const bundleIdProperty = paymentOptionsData.value.blocks.find(
				(b) => b.id === currentActiveBlock.value
			)?.bundle_id;
			let bundleId = null;
			if (lineItemProperty) {
				properties[lineItemProperty] = true;
			}

			if (bundleIdProperty) {
				const uniqueId = [bundleIdProperty, currentMainProductVarId.value];
				AtcPayload.value.forEach((p) => {
					uniqueId.push(p.id);
					if (p.selling_plan) {
						uniqueId.push(`plan_30`);
					}
				});
				uniqueId.push(`ts_${Date.now()}`);
				bundleId = uniqueId.join("_");
			}

			if (bundleId) {
				properties["_bundle_id"] = bundleId;
			}

			try {
				let sellingPlanElement = document.querySelector('input[name="selling_plan"]');
				let mainProduct = {
					quantity: addOnQty.value,
					id: parseInt(currentMainProductVarId.value),
					selling_plan: sellingPlanElement && sellingPlanElement.value ? sellingPlanElement.value : "",
					properties,
				};

				if (compare_at_price_percentage_property && compare_at_price_property) {
					mainProduct.properties = {
						...mainProduct.properties,
						_compare_at_price: compare_at_price_property.value,
						_compare_at_price_discount: compare_at_price_percentage_property.value,
					};
				}

				let atcProducts;
				if (
					paymentOptionsData.value.blocks.length == 1 &&
					paymentOptionsData.value.blocks[0].add_ons.length == 1 &&
					paymentOptionsData.value.blocks[0].add_ons[0].type == "gift_add_on"
				) {
					const productId = paymentOptionsData.value.blocks[0].add_ons[0].product.id;
					atcProducts = [
						{
							id: productId,
							quantity: 1,
						},
					];
				} else {
					atcProducts = AtcPayload.value.map((p) => {
						let properties = p.properties;
						if (lineItemProperty) {
							properties[lineItemProperty] = true;
						}
						if (bundleId) {
							properties["_bundle_id"] = bundleId;
						}
						return {
							...p,
							quantity: addOnQty.value,
							properties,
						};
					});
				}
				const widget = window.Rebuy.widgets.find((widget) => widget.id === "131604");
				if (widget && atcProducts.length) {
					widget.detachWidget();
				}
				console.log({ mainProduct, atcProducts }, "add to cart working");
				if (redirectToCheckout.value) Rebuy.SmartCart.skip_open = true;
				const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ items: [mainProduct, ...atcProducts] }),
				});
				const data = await response.json();
				if (data && redirectToCheckout.value) {
					let str = window.location.href.includes("/es/") ? "?locale=es" : "";
					str = "/checkout" + str;
					window.location.href = str;
				}
			} catch (error) {
				console.log(error);
			} finally {
				isSubmitting.value = false;
			}
		}

		async function getOGSellingPlans(productId) {
			try {
				let resp = await fetch(
					`https://us-central1-shopify-web-dev.cloudfunctions.net/OGIncentiveHC?productId=${productId}`,
					{
						method: "GET",
					}
				);
				return resp.json();
			} catch (error) {
				console.log(error);
			}
		}

		function handleBlockSelect(e, checkout_label, checkout_redirect, isOos, landing_page_redirect) {
			// console.log(landing_page_redirect,"landing page re direct");
			//console.log(checkout_label,isOos,asatest,"asa testing");
			currentActiveBlock.value = e;
			const atcBtn = document.querySelector("buy-buttons .button--add-to-cart");
			//console.log(atcBtn,"at to cart button");
			let atcBtnInrTxt = atcBtn.querySelector("div");
			//console.log(atcBtnInrTxt,atcBtn,"inner text");
			atcBtn.classList.remove("sold-out");
			atcBtn.classList.remove("button--subdued");
			atcBtn.removeAttribute("disabled");
			if (checkout_label !== undefined && checkout_label !== null && checkout_label !== "") {
				atcBtnInrTxt.textContent = checkout_label;
				// updating this attribute will prevent default behivour of theme to update the button text based on variant change
				atcBtn.setAttribute("data-button-content", checkout_label);
			}
			if (checkout_redirect !== undefined && checkout_redirect !== null && checkout_redirect !== "") {
				redirectToCheckout.value = checkout_redirect;
			}

			redirectToLp.value = null;
			if (landing_page_redirect && typeof landing_page_redirect === "string") {
				redirectToLp.value = landing_page_redirect;
			}

			if ((typeof isOos === "boolean" && isOos) || !checkMainProductAvailablility()) {
				atcBtnInrTxt.textContent = paymentOptionsData.value.oosLabel;
				atcBtn.setAttribute("data-button-content", paymentOptionsData.value.oosLabel);
				atcBtn.classList.add("sold-out");
				atcBtn.setAttribute("disabled", "");
			}
		}

		function checkMainProductAvailablility() {
			let selectedVariantId = currentMainProductVarId.value;
			const filteredMainProdVariant = paymentOptionsData.value.main_product.variants.find(
				(item) => item.id === +selectedVariantId
			);
			return filteredMainProdVariant ? filteredMainProdVariant.available : false;
		}

		function handeLineItemDispatch(e) {
			AtcPayload.value = e;
		}

		function hasBlackListedVariant(blackList = [], blockType) {
			if (blackList && blackList.length && blackList.includes(currentMainProductVarId.value)) {
				//console.log(currentMainProductVarId.value,"current variant product id");
				if (blockType === currentActiveBlock.value) {
					currentActiveBlock.value = "";
					const currentVariant = paymentOptionsData.value.main_product.variants.find(
						(v) => v.id === parseInt(currentMainProductVarId.value)
					);
					handleBlockSelect("", paymentOptionsData.value.defaultAtcLabel, false, !currentVariant.available, undefined);
					updateMainProductLinePrice(
						{
							sale_price: window.mainProductPrice.sale_price,
							discount_price: window.mainProductPrice.discount_price,
							savings: window.mainProductPrice.savings,
						},
						blockType
					);
					tabbyAndTamara(window.mainProductPrice.discount_price || window.mainProductPrice.sale_price);
				}
				return true;
			}
			return false;
		}

		function handleBlockUnSelect(e) {
			try {
				if (paymentOptionsData.value.block_input_type === "checkbox") {
					let atcBtn = document.querySelector("buy-buttons .button--add-to-cart");
					let atcBtnInrTxt = atcBtn.querySelector("div");
					currentActiveBlock.value = "";
					atcBtnInrTxt.textContent = paymentOptionsData.value.defaultAtcLabel;
					atcBtn.setAttribute("data-button-content", paymentOptionsData.value.defaultAtcLabel);
					if (redirectToLp.value) {
						redirectToLp.value = null;
					}
					updateMainProductLinePrice(
						{
							sale_price: window.mainProductPrice.sale_price,
							discount_price: window.mainProductPrice.discount_price,
							savings: window.mainProductPrice.savings,
						},
						undefined
					);
					tabbyAndTamara(window.mainProductPrice.discount_price || window.mainProductPrice.sale_price);
					renderAdditionalTagOrPriceOnMount(paymentOptionsData.value.blocks);
				}
			} catch (error) {
				console.error(error);
			}
		}

		return {
			paymentOptionsData,
			isLoading,
			hasBlackListedVariant,
			shouldRenderBlock,
			currentActiveBlock,
			handleBlockSelect,
			handleBlockUnSelect,
			handeLineItemDispatch,
			checkMainProductAvailablility,
			AtcPayload,
			addOnQty,
			doesSubAdnExist,
			eventsAttachedToAtc,
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("pb-pay-in-full", {
	template: "#payInFullBlock",
	emits: ["on-block-select", "on-line-item-dispatch", "on-block-unselect"],
	props: ["block_data", "block_active", "is_preselected", "payment_options_data", "input_type"],
	setup(props, ctx) {
		const doesSubAdnExist = ref(false);
		const morePerksBtnElRef = ref(null);
		const isOutOfStock = ref(false);
		const blockAddOnState = ref(
			props.block_data.add_ons
				.filter((a) => !a.hidden)
				.map((a) => {
					return {
						id: a.id,
						data: [],
					};
				})
		);
		const headerBlockPrice = ref({
			sale_price: 0,
			discount_price: 0,
			savings: [],
		});
		const discountForMainProductFrmAdnArr = ref(initBlockHeaderDiscount());
		const blockHiddenAddOnState = ref(
			props.block_data.add_ons
				.filter((a) => a.hidden)
				.map((a) => {
					return a.products;
				})
				.flat()
		);
		const annualPrepaidInfo = ref({});

		watch(blockAddOnState, () => {
			if (props.block_active) {
				dispatchLineItems();
				// update the addon discount on addon state changes when current block is active
				discountForMainProductFrmAdnArr.value = discountForMainProductFrmAdnArr.value.map((d) => {
					let activeAdn = blockAddOnState.value.find((b) => b.id === d.id);
					if (
						activeAdn.data.length &&
						activeAdn.data[0].purchase_type === "SUBSCRIPTION" &&
						(activeAdn.data[0]?.enable_discount === "SUBSCRIPTION" || activeAdn.data[0]?.enable_discount === "BOTH")
					) {
						return {
							id: d.id,
							discount_value: parseFloat(activeAdn.data[0].subscription_discount_value),
							discount_value_type: activeAdn.data[0].subscription_discount_value_type,
						};
					}
					if (
						activeAdn.data.length &&
						activeAdn.data[0].purchase_type === "ONE_TIME" &&
						(activeAdn.data[0]?.enable_discount === "ONE_TIME" || activeAdn.data[0]?.enable_discount === "BOTH")
					) {
						return {
							id: d.id,
							discount_value: parseFloat(activeAdn.data[0].one_time_discount_value),
							discount_value_type: activeAdn.data[0].one_time_discount_value_type,
						};
					}
					//console.log(activeAdn.data.length,activeAdn.data[0].purchase_type,activeAdn.data[0]?.enable_discount,"annual prepaid if conditions");
					if (
						activeAdn.data.length &&
						activeAdn.data[0].purchase_type === "ANNUAL_PREPAID" &&
						activeAdn.data[0]?.enable_discount === "ANNUAL_PREPAID"
					) {
						//console.log("annual prepaid");
						return {
							id: d.id,
							discount_value: parseFloat(activeAdn.data[0].annual_prepaid_discount_value),
							discount_value_type: activeAdn.data[0].annual_prepaid_discount_value_type,
						};
					}
					return {
						id: d.id,
						discount_value: 0,
						discount_value_type: "PERCENTAGE",
					};
				});
			}
			doesSubAdnExist.value = blockAddOnState.value
				.map((a) => a.data)
				.flat()
				.some((p) => p.purchase_type === "SUBSCRIPTION" || p.purchase_type === "ANNUAL_PREPAID");
			updateBlockHeaderPriceInfo();
		});

		// watcher callback runs on when block selected/unselected
		watch(
			() => props.block_active,
			() => {
				if (!props.block_active) {
					doesSubAdnExist.value = false;
					// reset block head price to default state
					discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
					blockAddOnState.value = blockAddOnState.value.map((a) => ({
						...a,
						data: [],
					}));
				} else {
					// console.log("calling update function when active");
					updateBlockHeaderPriceInfo();
					if (props.is_preselected) {
						dispatchLineItems();
					}
				}
			}
		);

		onMounted(() => {
			updateBlockHeaderPriceInfo();
			isOutOfStock.value = props.block_data.add_ons
				.map((a) => {
					return a.product || a.products;
				})
				.flat()
				.some((p) => p.availble === false);
			document.addEventListener("variant:change", variantChangedHandler);
			if (props.is_preselected) {
				//console.log(props.is_preselected,"preselected");
				ctx.emit(
					"on-block-select",
					props.block_data.id,
					props.block_data.add_to_cart_label,
					props.block_data.redirect_to_checkout,
					isOutOfStock.value
				);
			}
			updateAnnualPrepaidInfo();
			// updateTopLinePrice();
			if (morePerksBtnElRef.value) {
				morePerksBtnElRef.value.addEventListener("click", perksPopupToggleHandler);
			}
		});

		function perksPopupToggleHandler(e) {
			const modal = document.getElementById("perks-modal-pricing-modal");
			const closeModalBtn = document.querySelector(".perks-modal-close-btn");

			modal.style.display = "flex";

			// Close the modal when clicking the close button
			closeModalBtn.addEventListener("click", () => {
				modal.style.display = "none";
			});

			// Close the modal when clicking outside the modal content
			window.addEventListener("click", (e) => {
				if (e.target === modal) {
					modal.style.display = "none";
				}
			});
		}

		function updateAnnualPrepaidInfo() {
			const firstAvailableProduct = props.block_data.add_ons
				.find((a) => a.type === "add_on")
				.products.find((p) => p.available);
			if (props.block_data.show_annual_plan_ui && firstAvailableProduct) {
				const annualPlanSavings = {};
				const addonProductBasePrice = firstAvailableProduct.compare_at_price
					? firstAvailableProduct.compare_at_price
					: firstAvailableProduct.price;
				const freeAddon = props.block_data.add_ons.find((a) => a.type === "gift_add_on");
				const offerMonths = props.block_data?.annual_plan_free_months_offer || 0;
				const annualPrepaidDiscount = parseFloat(props.block_data?.annual_plan_discount) || 0;
				const totalBasePrice = addonProductBasePrice * 12;
				const billedToday = getTotalAnnualPrepaidPrice(firstAvailableProduct) || totalBasePrice;
				const salePriceOveride = parseFloat(props.block_data.sale_price) || 0;

				annualPlanSavings.free_diffuser = parseFloat(
					window.mainProductPrice.discount_price || window.mainProductPrice.sale_price
				);
				annualPlanSavings.total_savings = 0;

				if (salePriceOveride) {
					annualPlanSavings.total_savings += annualPlanSavings.free_diffuser;
				}

				if (offerMonths) {
					console.log(totalBasePrice, "annual base price", annualPrepaidDiscount);
					annualPlanSavings.annual_free_offer = totalBasePrice * (annualPrepaidDiscount / 100);
					annualPlanSavings.total_savings += annualPlanSavings.annual_free_offer;
				}

				if (billedToday) {
					annualPlanSavings.billed_today = billedToday;
				}

				if (freeAddon && freeAddon.product) {
					const giftAddonPrice = freeAddon.product.compare_at_price || freeAddon.product.price;
					annualPlanSavings.free_addon = {
						text: freeAddon.label,
						price: giftAddonPrice,
					};
					annualPlanSavings.total_savings += giftAddonPrice;
				}

				if (props.block_data?.annual_plan_shipping_discount) {
					annualPlanSavings.free_shipping_value = parseFloat(props.block_data?.annual_plan_shipping_discount * 100);
					annualPlanSavings.total_savings += annualPlanSavings.free_shipping_value;
				}

				annualPrepaidInfo.value = annualPlanSavings;
			}
		}

		function getTotalAnnualPrepaidPrice(product) {
			if (product) {
				const sellingPlan = product.selling_plan_allocations.find((s) =>
					s.selling_plan.name.includes("30 days, prepaid for 12 shipments")
				);
				return sellingPlan?.price;
			}
			return 0;
		}

		function variantChangedHandler() {
			if (props.block_active) {
				ctx.emit(
					"on-block-select",
					props.block_data.id,
					props.block_data.add_to_cart_label,
					props.block_data.redirect_to_checkout,
					isOutOfStock.value
				);
				updateBlockHeaderPriceInfo();
			}
		}

		onUnmounted(() => {
			document.removeEventListener("variant:change", variantChangedHandler);
		});

		function updateBlockHeaderPriceInfo() {
			const overidePrice = parseFloat(props.block_data.original_price) * 100 || 0;
			const overideSalePriceDiscount = parseFloat(props.block_data.sale_price) || 0;
			const priceRenderMode = props.block_data.price_render_mode;
			// getting top line price from global context.
			let salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = window.mainProductPrice.discount_price
				? parseFloat(window.mainProductPrice.discount_price)
				: null;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			// overide product price
			if (overidePrice) {
				salePrice = overidePrice;
			}
			if (overideSalePriceDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
				saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"discount from pay in full overide");
			}

			let addOnTotalDiscount = calculateTotalAdnDiscount(discountForMainProductFrmAdnArr.value, salePrice);
			//console.log(addOnTotalDiscount,"addon total discount");
			discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);
			if (addOnTotalDiscount) saveLabel = [formatSavingsLabel(addOnTotalDiscount)];
			//console.log(addOnTotalDiscount,discountPrice,saveLabel,"add on total discount and price");
			// if there is no addon discount fallback to default discount
			if (!addOnTotalDiscount) {
				discountPrice = window.mainProductPrice.discount_price
					? parseFloat(window.mainProductPrice.discount_price)
					: null;
				if (overideSalePriceDiscount) {
					discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
					saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				}
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"inside if there is no discount fallback");
			}

			// check if combined price is enabled if true then add the oil price with the main product price.
			if (priceRenderMode === "DISPLAY_COMBINED_PRICE") {
				// format the existing product label according to combined price.
				// *** the line bellow was temporary disabled until we figure out whats best.
				// if (addOnTotalDiscount) saveLabel = [`${addOnTotalDiscount.toFixed(2)}% OFF ${props.block_data.parent_product.title}`];

				if (addOnTotalDiscount) {
					saveLabel = [`${addOnTotalDiscount.toFixed(2)}% OFF ${props.block_data.parent_product.title}`];
				} else {
					saveLabel = [`${window?.mainProductPrice?.savings} OFF ${props.block_data.parent_product.title}`];
				}

				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				//console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - totalDiscountPrice);
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				// updating label from addons when combined price is enabled.
				saveLabel = getSavingsLabelForAddons(saveLabel, blockAddOnState.value);
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
					tabbyAndTamara(headerBlockPrice.value.discount_price || headerBlockPrice.value.sale_price);
				}
			} else if (priceRenderMode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT") {
				let totalCombinedDiscount = null;
				saveLabel = [];
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				// console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - (totalSalePrice - totalDiscountPrice));
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				totalCombinedDiscount = calculateDiscountPercentage(salePrice, discountPrice);
				// updating label from addons when combined price is enabled.
				if (totalCombinedDiscount) {
					saveLabel = [`${formatSavingsLabel(totalCombinedDiscount)}`];
					saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				}

				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
					tabbyAndTamara(headerBlockPrice.value.discount_price || headerBlockPrice.value.sale_price);
				}
			} else if (priceRenderMode === "DISPLAY_ADD_ON_PRICE") {
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}
				headerBlockPrice.value.sale_price = totalSalePrice;
				headerBlockPrice.value.discount_price = totalDiscountPrice || null;

				//Update the main product price with discounts
				if (props.block_active) {
					updateMainProductLinePrice(
						{
							sale_price: salePrice,
							discount_price: discountPrice,
							savings: renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data),
						},
						props.block_data.type
					);
				}
			} else if (priceRenderMode === "DISPLAY_MAIN_PRODUCT_PRICE") {
				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			}
		}

		/**
		 * Returns the default block header discount can be used on block active/inactive
		 * @returns {object} default block header discount array
		 */
		function initBlockHeaderDiscount() {
			return props.block_data.add_ons.map((a) => {
				if (
					(a.default_purchase_type === "SUBSCRIPTION" && a.enable_discount === "SUBSCRIPTION") ||
					a.enable_discount === "BOTH"
				) {
					return {
						id: a.id,
						discount_value: parseFloat(a.subscription_discount_value),
						discount_value_type: a.subscription_discount_value_type,
					};
				}
				if (
					(a.default_purchase_type === "ONE_TIME" && a.enable_discount === "ONE_TIME") ||
					a.enable_discount === "BOTH"
				) {
					return {
						id: a.id,
						discount_value: parseFloat(a.one_time_discount_value),
						discount_value_type: a.one_time_discount_value_type,
					};
				}

				return {
					id: a.id,
					discount_value: 0,
					discount_value_type: "PERCENTAGE",
				};
			});
		}

		function getTempProductSelection(addOn) {
			const firstAvailableProduct = addOn.products.find((p) => p.available);
			firstAvailableProduct.purchase_type = addOn.default_purchase_type;
			return firstAvailableProduct;
		}

		function dispatchLineItems() {
			let cartPayload = blockAddOnState.value
				.map((a) => {
					return a.data.map((p) => {
						let lineItem = {
							id: p.variant_id,
							properties: {
								_compare_at_price: p.compare_at_price ? p.compare_at_price : "0",
								_compare_at_price_discount: p.compare_at_price
									? Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100).toString()
									: "0",
							},
						};
						props.block_data.add_ons.forEach((add_on) => {
							if (a.id === add_on.id && add_on.type === 'gift_add_on') {
								lineItem = { ...lineItem, properties: { ...lineItem.properties, "_discount_settings": add_on.discount_settings } };
							}
						})
						if (p.purchase_type === "SUBSCRIPTION" || p.purchase_type === "ANNUAL_PREPAID") {
							lineItem.selling_plan = parseInt(p.selling_plan_id);
						}
						return lineItem;
					});
				})
				.flat();
			let hiddenProducts = blockHiddenAddOnState.value.map((p) => {
				return {
					id: p.id,
				};
			});
			cartPayload = [...cartPayload, ...hiddenProducts];
			ctx.emit("on-line-item-dispatch", cartPayload);
		}

		function handleBlockEnable(e) {
			if (!e.target.checked) {
				ctx.emit("on-block-unselect", null);
			} else {
				ctx.emit(
					"on-block-select",
					props.block_data.id,
					props.block_data.add_to_cart_label,
					props.block_data.redirect_to_checkout,
					isOutOfStock.value
				);
			}
		}

		function handleAddOnDisabled(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return { ...e, data: [] };
				}
				return a;
			});
		}

		function handleAddOnSelect(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handeGiftAddOn(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handleAddOnUpdate(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return {
						...a,
						data: a.data.map((p) => {
							if (p.variant_id === e.variant_id) {
								return {
									...p,
									purchase_type: e.purchase_type,
								};
							}
							return p;
						}),
					};
				}
				return a;
			});
		}

		return {
			doesSubAdnExist,
			blockAddOnState,
			blockHiddenAddOnState,
			headerBlockPrice,
			discountForMainProductFrmAdnArr,
			handleBlockEnable,
			formatMoneyy,
			annualPrepaidInfo,
			morePerksBtnElRef,
			calculateDiscountedPrice,
			handleAddOnDisabled,
			handleAddOnSelect,
			handleAddOnUpdate,
			handeGiftAddOn,
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("pb-multi-addon-block", {
	template: "#pbMultiAddonBlock",
	emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
	props: ["block_data", "block_active", "is_preselected", "payment_options_data", "input_type"],
	setup(props, ctx) {
		const doesSubAdnExist = ref(false);
		const blockAddOnState = ref(
			props.block_data.add_ons
				.filter((a) => !a.hidden)
				.map((a) => {
					return {
						id: a.id,
						data: [],
					};
				})
		);
		const headerBlockPrice = ref({
			sale_price: 0,
			discount_price: 0,
			savings: [],
		});
		const discountForMainProductFrmAdnArr = ref(initBlockHeaderDiscount());
		const isSubmitting = ref(false);
		const isValid = ref(false);
		const currentMainProductVarId = ref(null);
		const errMsg = ref('');
		let variantInputEl = null;

		onBeforeMount(() => {
			if (props.is_preselected) {
				ctx.emit("on-block-select", props.block_data.id, "", "", null);
			}
		})

		watch(() => props.block_active, () => {
			if (!props.block_active) {
				doesSubAdnExist.value = false;
				blockAddOnState.value = blockAddOnState.value.map((a) => ({
					...a,
					data: [],
				}));
			} else {
				discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
				updateBlockHeaderPriceInfo();
			}
		});

		watch(blockAddOnState, () => {
			isValid.value = blockAddOnState.value[0]?.data?.length === props.block_data.max_limit;
			if (blockAddOnState.value[0]?.data?.length) {
				doesSubAdnExist.value = blockAddOnState.value[0]?.data.some(p => p.purchase_type === 'SUBSCRIPTION');
			}
			discountForMainProductFrmAdnArr.value = discountForMainProductFrmAdnArr.value.map((d) => {
				let activeAdn = blockAddOnState.value.find((b) => b.id === d.id);
				if (
					activeAdn.data.length &&
					activeAdn.data[0].purchase_type === "SUBSCRIPTION" &&
					(activeAdn.data[0]?.enable_discount === "SUBSCRIPTION" || activeAdn.data[0]?.enable_discount === "BOTH")
				) {
					return {
						id: d.id,
						discount_value: parseFloat(activeAdn.data[0].subscription_discount_value),
						discount_value_type: activeAdn.data[0].subscription_discount_value_type,
					};
				}
				if (
					activeAdn.data.length &&
					activeAdn.data[0].purchase_type === "ONE_TIME" &&
					(activeAdn.data[0]?.enable_discount === "ONE_TIME" || activeAdn.data[0]?.enable_discount === "BOTH")
				) {
					return {
						id: d.id,
						discount_value: parseFloat(activeAdn.data[0].one_time_discount_value),
						discount_value_type: activeAdn.data[0].one_time_discount_value_type,
					};
				}
				//console.log(activeAdn.data.length,activeAdn.data[0].purchase_type,activeAdn.data[0]?.enable_discount,"annual prepaid if conditions");
				if (
					activeAdn.data.length &&
					activeAdn.data[0].purchase_type === "ANNUAL_PREPAID" &&
					activeAdn.data[0]?.enable_discount === "ANNUAL_PREPAID"
				) {
					//console.log("annual prepaid");
					return {
						id: d.id,
						discount_value: parseFloat(activeAdn.data[0].annual_prepaid_discount_value),
						discount_value_type: activeAdn.data[0].annual_prepaid_discount_value_type,
					};
				}
				return {
					id: d.id,
					discount_value: 0,
					discount_value_type: "PERCENTAGE",
				};
			});
			updateBlockHeaderPriceInfo();
		});

		function handleBlockEnable(e) {
			if (!e.target.checked) {
				ctx.emit("on-block-unselect", null);
			} else {
				ctx.emit("on-block-select", props.block_data.id, "", "", null);
			}
		}

		function variantChangedHandler(e) {
			if (props.block_active) {
				updateBlockHeaderPriceInfo();
			}
			variantInputEl = document.querySelector(".product-info__buy-buttons input[name='id']");
			currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
		}

		onMounted(() => {
			variantInputEl = document.querySelector(".product-info__buy-buttons input[name='id']");
			currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
			document.addEventListener("variant:change", variantChangedHandler);
		});

		onUnmounted(() => {
			document.removeEventListener("variant:change", variantChangedHandler);
		});

		function updateBlockHeaderPriceInfo() {
			const overidePrice = parseFloat(props.block_data.original_price) * 100 || 0;
			const overideSalePriceDiscount = parseFloat(props.block_data.sale_price) || 0;
			const priceRenderMode = props.block_data.price_render_mode;
			// getting top line price from global context.
			let salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = window.mainProductPrice.discount_price
				? parseFloat(window.mainProductPrice.discount_price)
				: null;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			// overide product price
			if (overidePrice) {
				salePrice = overidePrice;
			}
			if (overideSalePriceDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
				saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"discount from pay in full overide");
			}

			let addOnTotalDiscount = calculateTotalAdnDiscount(discountForMainProductFrmAdnArr.value, salePrice);
			//console.log(addOnTotalDiscount,"addon total discount");
			discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);
			if (addOnTotalDiscount) saveLabel = [formatSavingsLabel(addOnTotalDiscount)];
			//console.log(addOnTotalDiscount,discountPrice,saveLabel,"add on total discount and price");
			// if there is no addon discount fallback to default discount
			if (!addOnTotalDiscount) {
				discountPrice = window.mainProductPrice.discount_price
					? parseFloat(window.mainProductPrice.discount_price)
					: null;
				if (overideSalePriceDiscount) {
					discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
					saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				}
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"inside if there is no discount fallback");
			}

			// check if combined price is enabled if true then add the oil price with the main product price.
			if (priceRenderMode === "DISPLAY_COMBINED_PRICE") {
				// format the existing product label according to combined price.
				if (addOnTotalDiscount) {
					saveLabel = [`${addOnTotalDiscount.toFixed(2)}% OFF ${props.block_data.parent_product.title}`];
				} else {
					saveLabel = [`${window?.mainProductPrice?.savings} OFF ${props.block_data.parent_product.title}`];
				}

				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				//console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - totalDiscountPrice);
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				// updating label from addons when combined price is enabled.
				saveLabel = getSavingsLabelForAddons(saveLabel, blockAddOnState.value);
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT") {
				let totalCombinedDiscount = null;
				saveLabel = [];
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				//console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - (totalSalePrice - totalDiscountPrice));
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				totalCombinedDiscount = calculateDiscountPercentage(salePrice, discountPrice);
				// updating label from addons when combined price is enabled.
				if (totalCombinedDiscount) {
					saveLabel = [`${formatSavingsLabel(totalCombinedDiscount)}`];
					saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				}

				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "DISPLAY_ADD_ON_PRICE") {
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}
				headerBlockPrice.value.sale_price = totalSalePrice;
				headerBlockPrice.value.discount_price = totalDiscountPrice || null;

				//Update the main product price with discounts
				if (props.block_active) {
					updateMainProductLinePrice(
						{
							sale_price: salePrice,
							discount_price: discountPrice,
							savings: renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data),
						},
						props.block_data.type
					);
				}
			} else if (priceRenderMode === "DISPLAY_MAIN_PRODUCT_PRICE") {
				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			}
		}

		/**
		* Returns the default block header discount can be used on block active/inactive
		* @returns {object} default block header discount array
		*/
		function initBlockHeaderDiscount() {
			return props.block_data.add_ons.map((a) => {
				if (
					(a.default_purchase_type === "SUBSCRIPTION" && a.enable_discount === "SUBSCRIPTION") ||
					a.enable_discount === "BOTH"
				) {
					return {
						id: a.id,
						discount_value: parseFloat(a.subscription_discount_value),
						discount_value_type: a.subscription_discount_value_type,
					};
				}
				if (
					(a.default_purchase_type === "ANNUAL_PREPAID" && a.enable_discount === "ANNUAL_PREPAID") ||
					a.enable_discount === "BOTH"
				) {
					return {
						id: a.id,
						discount_value: parseFloat(a.annual_prepaid_discount_value),
						discount_value_type: a.annual_prepaid_discount_value_type,
					};
				}
				if (
					(a.default_purchase_type === "ONE_TIME" && a.enable_discount === "ONE_TIME") ||
					a.enable_discount === "BOTH"
				) {
					return {
						id: a.id,
						discount_value: parseFloat(a.one_time_discount_value),
						discount_value_type: a.one_time_discount_value_type,
					};
				}

				return {
					id: a.id,
					discount_value: 0,
					discount_value_type: "PERCENTAGE",
				};
			});
		}

		function handleAddOnDisabled(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return { ...e, data: [] };
				}
				return a;
			});
		}

		function handleAddOnSelect(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handleAddOnUpdate(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return {
						...a,
						data: a.data.map((p) => {
							if (p.variant_id === e.variant_id) {
								return {
									...p,
									purchase_type: e.purchase_type,
								};
							}
							return p;
						}),
					};
				}
				return a;
			});
		}

		async function handleAddToCart() {
			const compare_at_price_property = document.getElementById("line-item-custom-property");
			const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
			let properties = {};
			const lineItemProperty = props.block_data?.line_item_property;
			isSubmitting.value = true;
			errMsg.value = '';
			if (lineItemProperty) {
				const uniqueId = [lineItemProperty, currentMainProductVarId.value];
				blockAddOnState.value.forEach((a) => {
					a.data.forEach(p => {
						uniqueId.push(p.variant_id);
					});
					if (a.data.every(p => p.purchase_type === 'SUBSCRIPTION' && p?.selling_plan_id)) {
						uniqueId.push(`sub`);
					}
				});
				properties["_bundle_set"] = uniqueId.join("_");
				properties["_quarterly_bundle_id"] = Date.now().toString();
			}

			if (props.block_data.add_on_select_mode === 'multiple') {
				properties["_quaterly_subs_key"] = true;
			}

			try {
				let mainProduct = {
					quantity: 1,
					id: parseInt(currentMainProductVarId.value),
					properties,
				};
				if (compare_at_price_percentage_property && compare_at_price_property) {
					mainProduct.properties = {
						...mainProduct.properties,
						_compare_at_price: compare_at_price_property.value,
						_compare_at_price_discount: compare_at_price_percentage_property.value,
					};
				}
				let atcProducts = [];
				blockAddOnState.value.forEach(a => {
					a.data.forEach(p => {
						const sellingPlanId = p.purchase_type === 'SUBSCRIPTION' && p?.selling_plan_id ? p?.selling_plan_id : null;
						const existingProduct = atcProducts.find(item => item.id === p.variant_id && item.selling_plan === sellingPlanId);

						if (existingProduct) {
							existingProduct.quantity += 1;
							existingProduct.properties._bundle_qty = existingProduct.quantity;
						} else {
							atcProducts.push({
								id: p.variant_id,
								quantity: 1,
								selling_plan: sellingPlanId,
								properties: {
									...properties,
									_bundle_qty: 1
								}
							});
						}

					});
				});
				const widget = window.Rebuy.widgets.find(
					(widget) => widget.id === "52434" || widget.id === "201848"
				);
				if (widget) {
					const oilInCart = Rebuy.Cart.cart.items.find(item => item.product_type === 'Oil');
					if (atcProducts.length || oilInCart) {
						widget.detachWidget();
					}
				}
				if (props.block_data?.redirect_to_checkout) Rebuy.SmartCart.skip_open = true;
				const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ items: [mainProduct, ...atcProducts] }),
				});
				const data = await response.json();
				if (response.status !== 200) {
					if (data.message) {
						return errMsg.value = data.message;
					}
					throw new Error("Oops! Something went wrong while adding products to the cart.");
				}
				if (data && props.block_data?.redirect_to_checkout) {
					let str = window.location.href.includes("/es/") ? "?locale=es" : "";
					str = "/checkout" + str;
					window.location.href = str;
				}
			} catch (error) {
				console.log(error, "cart error");
				errMsg.value = "Oops! Something went wrong while adding products to the cart.";
			} finally {
				isSubmitting.value = false;
			}
		}

		return {
			handleBlockEnable,
			handleAddOnDisabled,
			handleAddOnUpdate,
			handleAddOnSelect,
			handleAddToCart,
			doesSubAdnExist,
			blockAddOnState,
			headerBlockPrice,
			currentMainProductVarId,
			discountForMainProductFrmAdnArr,
			isValid,
			isSubmitting,
			errMsg
		}
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("pb-lead-form", {
	template: "#leadFormBlock",
	emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
	props: ["block_data", "block_active", "is_preselected", "input_type"],
	setup(props, ctx) {
		let cbPayload = {
			quantity: 1,
			id: props.block_data.affiliate_product?.id || 0,
		};

		async function callbackFlow() {
			try {
				//console.log("called from outside of scope");
				if (props.block_data.callback_flow === "GO_TO_CHECKOUT") Rebuy.SmartCart.skip_open = true;
				if (props.block_data.submission_flow === "SUBMISSION_W_MAIN_PRODUCT") {
					cbPayload.id = parseInt(document.querySelector(".product-info__buy-buttons input[name='id']").value);
				}
				await handleCbATC();
				if (props.block_data.callback_flow === "GO_TO_CHECKOUT") {
					let str = window.location.href.includes("/es/") ? "?locale=es" : "";
					str = "/checkout" + str;
					window.location.href = str;
				}
			} catch (error) {
				// console.log(error, "Error while adding to cart");
			} finally {
				return 1;
			}
		}

		onMounted(() => {
			if (props.block_data.payment_url && props.block_data.payment_url != "") {
				window.dynamicFormPaymentUrlOverride = props.block_data.payment_url;
			}

			if (
				props.block_data.submission_flow === "SUBMISSION_W_MAIN_PRODUCT" ||
				props.block_data.submission_flow === "SUBMISSION_W_DUPLICATE_PRODUCT"
			) {
				if (
					props.block_data.submission_flow === "SUBMISSION_W_DUPLICATE_PRODUCT" &&
					!props.block_data.affiliate_product
				) {
					throw new Error(
						"Duplicate Affiliate product is not set bu the submission flow set to SUBMISSION_W_DUPLICATE_PRODUCT"
					);
				}
				window.submissionCallBack = callbackFlow;
			}

			if (props.is_preselected) {
				//console.log(props.is_preselected,"preselected");
				handleBlockEnable();
			}

			document.addEventListener("variant:change", variantChangedHandler);

			if (props.block_data.stripe_onboarding) {
				window.stripePriceVariantId = props.block_data.stripe_onboarding;
			}
		});

		function variantChangedHandler() {
			if (props.block_active) handleMainProductPriceUpdate();
		}

		onUnmounted(() => {
			document.removeEventListener("variant:change", variantChangedHandler);
		});

		function handleMainProductPriceUpdate() {
			const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
			const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			if (overideDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
				saveLabel = [formatSavingsLabel(overideDiscount)];
			}
			updateMainProductLinePrice(
				{
					sale_price: salePrice,
					discount_price: discountPrice,
					savings: saveLabel,
				},
				props.block_data.type
			);
		}

		function handleBlockEnable(e) {
			if (!e.target.checked) {
				ctx.emit("on-block-unselect", null);
			} else {
				ctx.emit("on-block-select", props.block_data.id, "", "", null);
			}
		}

		function handleButtonBlockToggle() {
			const input = document.getElementById(props.block_data.id);
			
			input.checked = !input.checked;
			input.dispatchEvent(new Event("change", { bubbles: true }));

			if (input.checked) {
				nextTick(() => {
					const formEl = document.querySelector(`#lf-wrapper-${props.block_data.id} .payment-block__body #LeadForm`);
					if (formEl) {
						formEl.scrollIntoView({ behavior: "smooth", block: "start" });
					}
				});
			}
		}

		watch(
			() => props.block_active,
			() => {
				const defaultAddToCartBtn = document.getElementById("AddToCart");
				if (props.block_active) {
					ctx.emit("on-lead-form-active", false);
					// update the discount price in the top line.
					defaultAddToCartBtn.style.display = "none";
					handleMainProductPriceUpdate();
				} else {
					defaultAddToCartBtn.style.display = "block";
				}
			}
		);

		async function handleCbATC() {
			await fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ items: [cbPayload] }),
			}).then((resp) => resp.json());
		}

		function handleMainProductPriceUpdate() {
			const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
			const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			if (overideDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
				saveLabel = [formatSavingsLabel(overideDiscount)];
			}
			updateMainProductLinePrice(
				{
					sale_price: salePrice,
					discount_price: discountPrice,
					savings: saveLabel,
				},
				props.block_data.type
			);
		}

		return {
			handleBlockEnable,
			handleButtonBlockToggle,
			formatMoneyy,
			calculateDiscountedPrice,
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("gift-add-on-block", {
	template: "#giftAddonBlock",
	emits: ["on-gift-addon"],
	props: ["add_on"],
	setup(props, ctx) {
		const isSelected = ref(false);
		const selectedProduct = ref();
		const isAddOnEnabled = ref(false);
		const isHidden = ref(props.add_on?.ui_hidden || false);

		onBeforeMount(() => {
			selectedProduct.value = props.add_on.product;
			if (selectedProduct.value) {
				isAddOnEnabled.value = true;
				ctx.emit("on-gift-addon", {
					id: props.add_on.id,
					data: [{ variant_id: selectedProduct.value.id }],
				});
			}
		});

		return {
			selectedProduct,
			isHidden,
			imgUrl,
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("add-on-block", {
	template: "#add-on-block",
	emits: ["on-addon-select", "on-addon-update", "on-addon-disabled"],
	props: ["add_on", "index", "block_data", "payment_options_data", "select_mode", "min_limit", "max_limit"],
	setup(props, ctx) {
		const isSelected = ref(false);
		const selectedProduct = ref([]);
		const dropdownOpen = ref(false);
		const isAddOnEnabled = ref(false);
		const filterOptions = ref(props.add_on.product_sets);
		const selectedFilter = ref("*");
		const filteredProductArr = ref(props.add_on.products);
		const searchString = ref("");
		const addonDropdownEl = ref(null);
		const mainProdPricing = ref(window.mainProductPrice);

		let purchaseOptions = [
			{
				type: "SUBSCRIPTION",
				label: "Monthly Subscription",
			},
			{
				type: "ANNUAL_PREPAID",
				label: "Annual Prepaid Subscription",
			},
			{
				type: "ONE_TIME",
				label: "One Time Purchase",
			},
		];
		const activePurchaseType = ref(props.add_on.default_purchase_type);
		purchaseOptions = purchaseOptions.filter(
			(po) =>
				po.type === props.add_on.purchase_type_option ||
				(props.add_on.purchase_type_option === "BOTH" && po.type != "ANNUAL_PREPAID")
		);

		onBeforeMount(() => {
			const variantId = document.querySelector(".product-info__buy-buttons input[name='id']")?.value;

			if (props.add_on.mandatory && props.select_mode === 'single') {
				isAddOnEnabled.value = true;
				handeVariantSelect(props.add_on.products.find((p) => p.available === true));
			}

			if (props.select_mode === 'multiple' && props.block_data?.max_limit) {
				selectedProduct.value = new Array(props.block_data?.max_limit).fill(null);
			}
			// preselecting the recommended addons
			if (variantId && props.add_on?.recommended_addon_mode) {
				handlePreselectOrPinRecommendedAddons({ detail: { variant: { id: variantId } } });
				if (props.add_on.mandatory && props.select_mode === 'single') {
					handeVariantSelect(filteredProductArr.value.find((p) => p.available === true));
				}
			}
			document.addEventListener('variant:change', handlePreselectOrPinRecommendedAddons);
		});

		onUnmounted(() => {
			document.removeEventListener('variant:changed', handlePreselectOrPinRecommendedAddons);
		});

		function handlePreselectOrPinRecommendedAddons(e) {
			const selectedMainProductVariant = e?.detail?.variant?.id || null;
			const mainProductVariantList = window?.pdpProduct?.variants || [];
			if (selectedMainProductVariant && mainProductVariantList?.length) {
				const recommendedAddonId = mainProductVariantList.find((v) => v.id == selectedMainProductVariant)?.matching_addon;
				const recommendedAddonVariant = props.add_on.products.find((p) => p.available === true && p.id == recommendedAddonId);
				
				if (props.add_on?.recommended_addon_mode === "PRE_SELECT" && recommendedAddonVariant) {
					handeVariantSelect(recommendedAddonVariant);
				}

				if (props.add_on?.recommended_addon_mode === "PINNED_AT_TOP") {
					resetSetFilter();
					const productArr = [...filteredProductArr.value];
					const recommendedAddonIndex = productArr.findIndex(p => p.id == recommendedAddonId);
					if (recommendedAddonIndex > -1 && recommendedAddonVariant) {
						productArr.splice(recommendedAddonIndex, 1);
						productArr.unshift(recommendedAddonVariant);
						filteredProductArr.value = productArr;
					}
				}
			}
		}

		function toggleAddOnEnable() {
			isAddOnEnabled.value = !isAddOnEnabled.value;
			if (!isAddOnEnabled.value && selectedProduct.value.length) {
				ctx.emit("on-addon-disabled", { id: props.add_on.id });
				selectedProduct.value = [];
			}
			if (isAddOnEnabled.value && props.select_mode === 'single') {
				handeVariantSelect(props.add_on.products[0]);
			}
		}

		function handleRemove(index) {
			let tempSelectedProductArr = [...selectedProduct.value];
			tempSelectedProductArr.splice(index, 1);
			tempSelectedProductArr.push(null);
			selectedProduct.value = tempSelectedProductArr;
			ctx.emit("on-addon-select", {
				id: props.add_on.id,
				data: selectedProduct.value.filter(p => p !== null).map((p) => {
					return {
						variant_id: p.id,
						purchase_type: activePurchaseType.value,
						enable_discount: props.add_on.enable_discount,
						one_time_discount_value: props.add_on.one_time_discount_value,
						one_time_discount_value_type: props.add_on.one_time_discount_value_type,
						subscription_discount_value_type: props.add_on.subscription_discount_value_type,
						subscription_discount_value: props.add_on.subscription_discount_value,
						annual_prepaid_discount_value_type: props.add_on.annual_prepaid_discount_value_type,
						annual_prepaid_discount_value: props.add_on.annual_prepaid_discount_value,
						selling_plan_id: setSellingPlanId(p),
						price_info: p.price_info,
						variant_title: p.name,
						compare_at_price: p.compare_at_price,
						price: p.price,
					}
				})
			});
		}

		function handeVariantSelect(product) {
			if (props.select_mode === 'multiple') {
				let tempSelectedProductArr = selectedProduct.value;
				for (let i = 0; i < tempSelectedProductArr.length; i++) {
					const p = tempSelectedProductArr[i];
					if (p === null) {
						tempSelectedProductArr[i] = product;
						break;
					}
				}
				selectedProduct.value = tempSelectedProductArr;
				ctx.emit("on-addon-select", {
					id: props.add_on.id,
					data: selectedProduct.value.filter(p => p !== null).map((p) => {
						return {
							variant_id: p.id,
							purchase_type: activePurchaseType.value,
							enable_discount: props.add_on.enable_discount,
							one_time_discount_value: props.add_on.one_time_discount_value,
							one_time_discount_value_type: props.add_on.one_time_discount_value_type,
							subscription_discount_value_type: props.add_on.subscription_discount_value_type,
							subscription_discount_value: props.add_on.subscription_discount_value,
							annual_prepaid_discount_value_type: props.add_on.annual_prepaid_discount_value_type,
							annual_prepaid_discount_value: props.add_on.annual_prepaid_discount_value,
							selling_plan_id: setSellingPlanId(p),
							price_info: p.price_info,
							variant_title: p.name,
							compare_at_price: p.compare_at_price,
							price: p.price,
						}
					})
				});
			} else {
				isAddOnEnabled.value = true;
				selectedProduct.value = [product];
				if (props.add_on.purchase_type_option != "BOTH") {
					if (
						selectedProduct.value[0].selling_plan_allocations.length > 0 &&
						props.add_on.purchase_type_option === "SUBSCRIPTION"
					) {
						activePurchaseType.value = props.add_on.purchase_type_option;
					} else if (props.add_on.purchase_type_option === "ANNUAL_PREPAID") {
						activePurchaseType.value = props.add_on.purchase_type_option;
					} else {
						activePurchaseType.value = "ONE_TIME";
					}
				} else {
					if (
						props.add_on.default_purchase_type === "SUBSCRIPTION" &&
						selectedProduct.value[0].selling_plan_allocations.length > 0
					) {
						activePurchaseType.value = props.add_on.default_purchase_type;
					} else if (props.add_on.default_purchase_type === "ANNUAL_PREPAID") {
						activePurchaseType.value = props.add_on.default_purchase_type;
					} else {
						activePurchaseType.value = "ONE_TIME";
					}
				}
				//console.log(selectedProduct.value[0].selling_plan_allocations.length, "selling plan");
				if (!isSelected.value) isSelected.value = true;
				ctx.emit("on-addon-select", {
					id: props.add_on.id,
					data: selectedProduct.value.map((p) => {
						return {
							variant_id: p.id,
							purchase_type: activePurchaseType.value,
							enable_discount: props.add_on.enable_discount,
							one_time_discount_value: props.add_on.one_time_discount_value,
							one_time_discount_value_type: props.add_on.one_time_discount_value_type,
							subscription_discount_value_type: props.add_on.subscription_discount_value_type,
							subscription_discount_value: props.add_on.subscription_discount_value,
							annual_prepaid_discount_value_type: props.add_on.annual_prepaid_discount_value_type,
							annual_prepaid_discount_value: props.add_on.annual_prepaid_discount_value,
							selling_plan_id: setSellingPlanId(p),
							price_info: p.price_info,
							variant_title: p.name,
							compare_at_price: p.compare_at_price,
							price: p.price,
						};
					}),
				});
				dropdownOpen.value = false;
			}
		}

		function setSellingPlanId(variant) {
			if (activePurchaseType.value === "SUBSCRIPTION" || activePurchaseType.value === "ONE_TIME") {
				return variant.og_selling_plan_id;
			} else if (activePurchaseType.value === "ANNUAL_PREPAID") {
				return variant.annual_selling_plan_id;
			} else {
				return null;
			}
		}

		function handleRadioCheck(product) {
			let checked = false;
			if (selectedProduct.value.length && selectedProduct.value[0].id === product.id) checked = true;
			return checked;
		}

		function toggleDropdown() {
			if (props.add_on.products.length > 1) {
				dropdownOpen.value = !dropdownOpen.value;
			}
		}

		function handlePurchasePlanSelect(type) {
			if (type === "SUBSCRIPTION" && selectedProduct.value[0].selling_plan_allocations.length > 0) {
				activePurchaseType.value = type;
			} else if (
				type === "ANNUAL_PREPAID" &&
				selectedProduct.value[0].prepaid_eligible &&
				selectedProduct.value[0].annual_selling_plan_id
			) {
				activePurchaseType.value = type;
			} else {
				activePurchaseType.value = "ONE_TIME";
			}
			ctx.emit("on-addon-update", {
				id: props.add_on.id,
				variant_id: selectedProduct.value[0].id,
				purchase_type: activePurchaseType.value,
				selling_plan_id: setSellingPlanId(selectedProduct.value[0]),
			});
		}

		function shouldRenderPurchaseOption(type) {
			if (
				(type === "SUBSCRIPTION" || type === "ANNUAL_PREPAID") &&
				!selectedProduct.value[0].selling_plan_allocations.length
			) {
				return false;
			}
			return true;
		}

		function renderNoResults() {
			return searchString.value == "" ? "No products found" : `No products found for '${searchString.value}'`;
		}

		function resetSearchFilter() {
			searchString.value = "";
			resetSetFilter();
		}

		function handleSearch(e) {
			//console.log(e.target.value);
			searchString.value = e.target.value;
			if (searchString.value.length > 0) {
				filteredProductArr.value = props.add_on.products.filter((p) => {
					const regex = new RegExp(searchString.value, "i");
					if (regex.test(p.name)) return p;
				});
			} else {
				handeFilterChange(selectedFilter.value);
			}
		}

		function resetSetFilter() {
			selectedFilter.value = "*";
			filteredProductArr.value = props.add_on.products;
			if (addonDropdownEl.value) {
				addonDropdownEl.value.scrollTo({
					top: 0,
				});
			}
		}

		function handeFilterChange(e) {
			selectedFilter.value = e;
			filteredProductArr.value = props.add_on.products.filter((p) => p.set_id.includes(e));
			if (selectedFilter.value === "*") {
				filteredProductArr.value = props.add_on.products;
			}
			if (searchString.value.length > 0) {
				filteredProductArr.value = filteredProductArr.value.filter((p) => {
					const regex = new RegExp(searchString.value, "i");
					if (regex.test(p.name)) return p;
				});
			}
			addonDropdownEl.value.scrollTo({
				top: 0,
			});
		}

		function handleChecked(id) {
			return id === selectedFilter.value;
		}

		function removeDecimal(value) {
			return parseInt(value);
		}

		return {
			imgUrl,
			formatMoneyy,
			handeVariantSelect,
			toggleDropdown,
			handleRadioCheck,
			calculateDiscountedPrice,
			handlePurchasePlanSelect,
			toggleAddOnEnable,
			generatePaymentOptionLabels,
			shouldRenderPurchaseOption,
			handleSearch,
			resetSearchFilter,
			renderNoResults,
			handleChecked,
			handeFilterChange,
			resetSetFilter,
			removeDecimal,
			handleRemove,
			isSelected,
			addonDropdownEl,
			filterOptions,
			filteredProductArr,
			selectedProduct,
			dropdownOpen,
			selectedFilter,
			searchString,
			purchaseOptions,
			isAddOnEnabled,
			activePurchaseType,
			mainProdPricing,
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("subscription-benefit-block", {
	template: "#subscription-benefit-block",
	props: ["subs_benefit", "is_annual_plan"],
	setup(props) { },
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("build-a-plan", {
	template: "#buildAPlanBlock",
	emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
	props: ["block_data", "block_active", "is_preselected", "input_type"],
	setup(props, ctx) {
		watch(
			() => props.block_active,
			() => {
				if (props.block_active) {
					const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
					// console.log("🚀 ~ watch ~ overideDiscount:", overideDiscount)
					const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
					let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
					let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
					if (overideDiscount) {
						discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
						saveLabel = [formatSavingsLabel(overideDiscount)];
					}
					updateMainProductLinePrice(
						{
							sale_price: salePrice,
							discount_price: discountPrice,
							savings: saveLabel,
						},
						props.block_data.type
					);
				}
			}
		);

		onMounted(() => {
			if (props.is_preselected) {
				//console.log(props.is_preselected,"preselected");
				handleBlockEnable();
			}
			document.addEventListener("variant:change", variantChangedHandler);
		});

		function variantChangedHandler() {
			if (props.block_active) handleMainProductPriceUpdate();
		}

		onUnmounted(() => {
			document.removeEventListener("variant:change", variantChangedHandler);
		});

		function handleMainProductPriceUpdate() {
			const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
			const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			if (overideDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
				saveLabel = [formatSavingsLabel(overideDiscount)];
			}
			updateMainProductLinePrice(
				{
					sale_price: salePrice,
					discount_price: discountPrice,
					savings: saveLabel,
				},
				props.block_data.type
			);
		}

		function handleBlockEnable(e) {
			if (!e.target.checked) {
				ctx.emit("on-block-unselect", null);
			} else {
				ctx.emit(
					"on-block-select",
					props.block_data.id,
					props.block_data.add_to_cart_label,
					"",
					null,
					props.block_data.landing_page
				);
			}
		}

		return {
			handleBlockEnable,
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component('override-add-to-cart', {
	template: "#pbOverrideATCBlock",
	emits: [],
	props: ["block_data", "payment_options_data"],
	setup(props, ctx) {

		const selectedMainProdVariant = ref(null);
		const isSubmitting = ref(false);
		const isSticky = ref(false)
		const stickyBtn = ref(null)

		onBeforeMount(() => {
			document.querySelector(".product-info__buy-buttons-wrapper").style.display = "none";
			document.querySelector("product-quick-add ").style.display = "none";
			const selectedFirstAvailableVariant = document.querySelector('.product-info__buy-buttons-wrapper form input[name="id"]').value;

			if (selectedFirstAvailableVariant) {
				console.log('selectedFirstAvailableVariant', selectedFirstAvailableVariant)
				selectedMainProdVariant.value = getSelectedVariantDetail(selectedFirstAvailableVariant);
			}
			document.addEventListener("variant:changed", variantChangedHandler);
		})

		onMounted(() => {
			window.addEventListener('scroll', handleScroll)
		})

		onUnmounted(() => {
			window.removeEventListener('scroll', handleScroll)
		})

		function getSelectedVariantDetail(variantId) {
			console.log(variantId)
			const variant = props.payment_options_data.main_product.variants.find(variant => variant.id === +variantId);
			return variant;
		}

		function variantChangedHandler(e) {
			if (e?.detail?.variant) {
				selectedMainProdVariant.value = e?.detail?.variant;
			}
		}

		async function handleATC() {
			const compare_at_price_property = document.getElementById("line-item-custom-property");
			const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
			isSubmitting.value = true;

			let mainProduct = {
				quantity: 1,
				id: parseInt(selectedMainProdVariant.value.id),
				properties: {
					_compare_at_price: compare_at_price_property.value,
					_compare_at_price_discount: compare_at_price_percentage_property.value,
				}
			};

			const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ items: [mainProduct] }),
			});
			const data = await response.json();

			if (data) {
				isSubmitting.value = false;
			}
		}

		const handleScroll = () => {
			if (window.innerWidth >= 769) {
				isSticky.value = false
				return
			}
			const scrollTop = window.scrollY
			const windowHeight = window.innerHeight
			const documentHeight = document.documentElement.scrollHeight

			// 25% of the page scrolled
			if (scrollTop >= (documentHeight - windowHeight) * 0.25) {
				isSticky.value = true
			} else {
				isSticky.value = false
			}
		}




		return {
			selectedMainProdVariant,
			isSubmitting,
			isSticky,
			stickyBtn,
			handleATC,
			formatMoneyy
		}
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.mount("#paymentBlocksApp");

function imgUrl(url, size) {
	// remove any current image size then add the new image size
	return url
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
			return "_" + size + match;
		});
}

function formatMoneyy(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
		formatString = format || window.themeVariables.settings.moneyFormat;
	function defaultTo(value2, defaultValue) {
		return value2 == null || value2 !== value2 ? defaultValue : value2;
	}
	function formatWithDelimiterss(number, precision, thousands, decimal) {
		precision = defaultTo(precision, 2);
		thousands = defaultTo(thousands, ",");
		decimal = defaultTo(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		number = roundNumber(number / 100, false, precision);
		let parts = number.split("."),
			dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
			centsAmount = parts[1] ? decimal + parts[1] : "";
		return dollarsAmount + centsAmount;
	}
	let value = "";
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiterss(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiterss(cents, 0);
			break;
		case "amount_with_space_separator":
			value = formatWithDelimiterss(cents, 2, " ", ".");
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiterss(cents, 2, ".", ",");
			break;
		case "amount_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 2, "'", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiterss(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiterss(cents, 0, " ");
			break;
		case "amount_no_decimals_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 0, "'");
			break;
	}
	if (formatString.indexOf("with_comma_separator") !== -1) {
		return formatString.replace(placeholderRegex, value);
	} else {
		return formatString.replace(placeholderRegex, value);
	}
}

function roundNumber(num, savings, precision = 2) {
	if (isNaN(num)) {
		return;
	}

	let nummm = num.toFixed(3).split(".")[1].slice(2);
	if (nummm > 4 && !savings) {
		let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else if (nummm < 6 && savings) {
		let number = Math.floor((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else {
		let number = Math.round((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	}
}

function calculateDiscountedPrice(salePrice = 0, discount = 0) {
	if (salePrice <= 0 || discount <= 0) {
		return null;
	}
	const discountAmount = (discount / 100) * salePrice;
	const discountedPrice = salePrice - discountAmount;

	return discountedPrice;
}

/**
 * Calculates the discounted prices for a product variant based on site-wide , collection and variant specific discounts.
 *
 * @param {Object} variant - The product variant object. *
 * @returns {Object} - The discounted prices and percentages for both one-time and subscription purchases.
 */
function calculateDiscount(variant) {
	const isSiteWideDiscountEnabled = variant?.site_wide_discount || false;
	const siteWideDiscountValue = parseFloat(variant?.site_wide_discount_value) || 0;
	const isCollectionDiscountEnabled = variant?.collection_disc_check || false;
	const { collectionDiscount, prioritizeDiscount, discountAppliesTo, subscriptionOveride } =
		getMaxCollectionWideDiscount(variant.collections, variant.collection_disc_check);
	const variantSubsDiscountValue = parseFloat(variant?.variant_discount_subs) || 0;
	const variantOnetimeDiscountValue = parseFloat(variant?.variant_discount_one_time) || 0;
	const ogDiscount = parseFloat(variant?.og_discount) || 0;
	// Exclusive discount for quarterly subscribers
	const additionalDiscount = parseFloat(variant?.additional_discount) || 0;

	let doesCompareAtPriceExist = false;
	let variantSalePrice = variant.price;
	if (variant.compare_at_price > variant.price) {
		variantSalePrice = variant.compare_at_price;
		doesCompareAtPriceExist = true;
	}

	const productPriceObj = {
		price: variantSalePrice,
		SUBSCRIPTION: {
			discount_price: doesCompareAtPriceExist ? variant.price : 0,
			discount_percentage: doesCompareAtPriceExist
				? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
				: 0,
			og_discount: ogDiscount,
			_debug_log: "",
		},
		ONE_TIME: {
			discount_price: doesCompareAtPriceExist ? variant.price : 0,
			discount_percentage: doesCompareAtPriceExist
				? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
				: 0,
			_debug_log: "",
		},
		ANNUAL_PREPAID: {
			discount_price: 0,
			discount_percentage: 0,
			og_discount: ogDiscount,
			_debug_log: "",
		},
	};

	if (isSiteWideDiscountEnabled && siteWideDiscountValue) {
		productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
		productPriceObj.ONE_TIME.discount_percentage = siteWideDiscountValue;
		productPriceObj.ONE_TIME._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
		productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
		productPriceObj.SUBSCRIPTION.discount_percentage = siteWideDiscountValue;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
		//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
		//productPriceObj.ANNUAL_PREPAID.discount_percentage = siteWideDiscountValue;
		//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
	}

	if (isCollectionDiscountEnabled && collectionDiscount) {
		const subscriptionDiscount = subscriptionOveride || collectionDiscount;
		// reset before setting collection discounts
		productPriceObj.ONE_TIME.discount_price = 0;
		productPriceObj.ONE_TIME.discount_percentage = 0;
		productPriceObj.SUBSCRIPTION.discount_price = 0;
		productPriceObj.SUBSCRIPTION.discount_percentage = 0;
		//productPriceObj.ANNUAL_PREPAID.discount_price = 0;
		//productPriceObj.ANNUAL_PREPAID.discount_percentage = 0;

		// if set true ignores site-wide
		if (prioritizeDiscount) {
			// subscription overide will always overide regardless of discountAppliesTo
			if (subscriptionOveride) {
				productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
				productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
				productPriceObj.SUBSCRIPTION._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
				//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
				//productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionDiscount;
				//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
			}

			if (discountAppliesTo === "One-time" || discountAppliesTo === "One-time and Subscription") {
				productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, collectionDiscount);
				productPriceObj.ONE_TIME.discount_percentage = collectionDiscount;
				productPriceObj.ONE_TIME._debug_log = `Applying collection priority discount ${collectionDiscount}`;
			}

			if (discountAppliesTo === "Subscription" || discountAppliesTo === "One-time and Subscription") {
				productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
				productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
				productPriceObj.SUBSCRIPTION._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
				//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
				//productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionDiscount;
				//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
			}
		} else {
			// if collection discount is not prioritized compare site wide and collection wide discount and apply which one is greater
			if (siteWideDiscountValue >= collectionDiscount && isSiteWideDiscountEnabled) {
				productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
				productPriceObj.ONE_TIME.discount_percentage = siteWideDiscountValue;
				productPriceObj.ONE_TIME._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
				productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
				productPriceObj.SUBSCRIPTION.discount_percentage = siteWideDiscountValue;
				productPriceObj.SUBSCRIPTION._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
				//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
				//productPriceObj.ANNUAL_PREPAID.discount_percentage = siteWideDiscountValue;
				//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
			} else {
				// subscription overide will always overide regardless of discountAppliesTo
				if (subscriptionOveride) {
					productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionOveride);
					productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionOveride;
					productPriceObj.SUBSCRIPTION._debug_log = `Applying collection discount ${subscriptionOveride}`;
					//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionOveride);
					//productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionOveride;
					//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection discount ${subscriptionOveride}`;
				}

				if (discountAppliesTo === "One-time" || discountAppliesTo === "One-time and Subscription") {
					productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, collectionDiscount);
					productPriceObj.ONE_TIME.discount_percentage = collectionDiscount;
					productPriceObj.ONE_TIME._debug_log = `Applying collection discount ${collectionDiscount}`;
				}

				if (discountAppliesTo === "Subscription" || discountAppliesTo === "One-time and Subscription") {
					productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(
						variantSalePrice,
						subscriptionDiscount
					);
					productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
					productPriceObj.SUBSCRIPTION._debug_log = `Applying collection discount ${subscriptionDiscount}`;
					//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
					//productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionDiscount;
					//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection discount ${subscriptionDiscount}`;
				}
			}
		}
	}

	// if(annualPrepaidDiscount){
	// 	productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice,annualPrepaidDiscount);
	// 	productPriceObj.ANNUAL_PREPAID.discount_percentage = annualPrepaidDiscount;
	// 	productPriceObj.ANNUAL_PREPAID._debug_log = `Applying Annual Prepaid Discount ${annualPrepaidDiscount}`;
	// }

	// variant level discounts gets the highest priority
	if (variantOnetimeDiscountValue) {
		productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, variantOnetimeDiscountValue);
		productPriceObj.ONE_TIME.discount_percentage = variantOnetimeDiscountValue;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount ${variantOnetimeDiscountValue}`;
	}

	if (variantSubsDiscountValue) {
		productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, variantSubsDiscountValue);
		productPriceObj.SUBSCRIPTION.discount_percentage = variantSubsDiscountValue;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount ${variantSubsDiscountValue}`;
		//productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, variantSubsDiscountValue);
		//productPriceObj.ANNUAL_PREPAID.discount_percentage = variantSubsDiscountValue;
		//productPriceObj.ANNUAL_PREPAID._debug_log = `Applying Variant discount ${variantSubsDiscountValue}`;
	}

	if (additionalDiscount) {
		productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, additionalDiscount);
		productPriceObj.SUBSCRIPTION.discount_percentage = additionalDiscount;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying additional discount ${additionalDiscount}`;
	}

	// remove debug logs
	if (false) {
		delete productPriceObj.SUBSCRIPTION._debug_log;
		delete productPriceObj.ONE_TIME._debug_log;
	}

	return productPriceObj;
}

/**
 * Checks if there are any selling plans.
 *
 * This function takes an array of selling plans and returns a boolean
 * indicating whether there are any plans present.
 *
 * @param {Array} plans - An array of selling plans.
 * @returns {boolean} True if there are selling plans, false otherwise.
 */
function checkSellingPlans(plans) {
	return plans && plans.length ? true : false;
}

/**
 * Gets the maximum value discount information for a collection.
 * @param {Array<Object>} collections - The array of collection objects.
 * @param {boolean} enableCollectionDiscount - Flag to enable collection discount.
 * @returns {Object} - An object containing collection discount information.
 */
function getMaxCollectionWideDiscount(collections = [], enableCollectionDiscount) {
	if (!collections || !collections.length || !enableCollectionDiscount) {
		return {
			collectionDiscount: 0,
			prioritizeDiscount: false,
			discountAppliesTo: "One-time and Subscription",
			subscriptionOveride: 0,
		};
	}

	const collectionDiscountMetafields = collections
		.filter((c) => {
			if (c.metafields && c.metafields.hasOwnProperty("collection_discount")) {
				return c;
			}
		})
		.map((c) => {
			return {
				...c.metafields,
				collection_discount: parseFloat(c.metafields.collection_discount),
			};
		})
		.sort((a, b) => b.collection_discount - a.collection_discount);
	// console.log("🚀 ~ collectionDiscountMetafields ~ collectionDiscountMetafields:", collectionDiscountMetafields)

	if (collectionDiscountMetafields && collectionDiscountMetafields.length) {
		const currentCollectionDiscount = collectionDiscountMetafields[0];
		return {
			collectionDiscount: currentCollectionDiscount.collection_discount,
			prioritizeDiscount: currentCollectionDiscount?.prioritize_discount || false,
			discountAppliesTo: currentCollectionDiscount?.discount_applies_to?.[0] || "One-time and Subscription",
			subscriptionOveride: parseFloat(currentCollectionDiscount?.subscription_discount_override) || 0,
		};
	}

	return {
		collectionDiscount: 0,
		prioritizeDiscount: false,
		discountAppliesTo: "One-time and Subscription",
		subscriptionOveride: 0,
	};
}

/**
 * The function `generatePaymentOptionLabels` generates labels for payment options based on the
 * selected product and active purchase type.
 * @param {Array<Object>} selectedProduct - selectedProduct is an array containing information about the product
 * selected by the user. It seems to contain details such as product metadata, price information, and
 * discount percentages for different purchase types. The function generates payment option labels
 * based on the selected product and active purchase type.
 * @param {string} activePurchaseType - The function `generatePaymentOptionLabels` takes two parameters:
 * `selectedProduct` and `activePurchaseType`. The `selectedProduct` parameter is an array containing
 * the selected product, and the `activePurchaseType` parameter specifies the type of purchase (e.g.,
 * 'ONE_TIME' or 'RE
 * @returns {string} - An string which represents the label based on conditions selected
 */
function generatePaymentOptionLabels(selectedProduct, activePurchaseType) {
	let product = selectedProduct[0];

	// Validate product and necessary properties
	if (!product || !product.price_info || !product.price_info[activePurchaseType]) {
		return "";
	}

	if (activePurchaseType === "ONE_TIME") {
		// Product card label metafields take highest priority
		if (product.main_product && product.main_product.product_metafield_label) {
			return product.main_product.product_metafield_label.map((label) => label.title).join(" ");
		}

		let discountPercentage = product.price_info[activePurchaseType].discount_percentage;
		if (discountPercentage && discountPercentage != 0) {
			return `${discountPercentage.toFixed()}% Off`;
		}
	} else if (activePurchaseType === "SUBSCRIPTION") {
		let labelStr = "";
		let saleDiscount = product.price_info[activePurchaseType].discount_percentage;
		let ogDiscount = product.price_info[activePurchaseType].og_discount;

		if (saleDiscount > 0) {
			labelStr = `${saleDiscount.toFixed()}% off now`;
		}

		if (ogDiscount && ogDiscount === saleDiscount) {
			labelStr = `${saleDiscount.toFixed()}% off now and on future orders`;
		} else if (ogDiscount && saleDiscount && ogDiscount != saleDiscount) {
			labelStr = `${saleDiscount.toFixed()}% off now, ${ogDiscount}% off on future orders`;
		} else if (saleDiscount <= 0 && ogDiscount) {
			labelStr = `${ogDiscount}% off on future orders`;
		}

		return labelStr;
	} else if (activePurchaseType === "ANNUAL_PREPAID") {
		let labelStr = "";
		let saleDiscount = product.price_info[activePurchaseType].discount_percentage;
		let ogDiscount = product.price_info[activePurchaseType].og_discount;

		if (saleDiscount > 0) {
			labelStr = `${saleDiscount.toFixed()}% off now`;
		}

		if (ogDiscount && ogDiscount === saleDiscount) {
			labelStr = `${saleDiscount.toFixed()}% off now and on future orders`;
		} else if (ogDiscount && saleDiscount && ogDiscount != saleDiscount) {
			labelStr = `${saleDiscount.toFixed()}% off now, ${ogDiscount}% off on future orders`;
		} else if (saleDiscount <= 0 && ogDiscount) {
			labelStr = `${ogDiscount}% off on future orders`;
		}

		return labelStr;
	}

	return "";
}
/**
 * Extracts the numerical value from a string containing a currency symbol.
 *
 * @param {string} currencyString - The string containing the currency value.
 * @returns {number} - The extracted numerical value as a whole number after multiplying by 100.
 */
function extractNumber(currencyString) {
	const numberString = currencyString.replace(/[^\d.-]/g, "");
	const number = parseFloat(numberString);
	return Math.round(number * 100);
}

/**
 * @typedef {Object} AddonDiscount
 * @property {string} id - The unique identifier for the discount.
 * @property {number} discount_value - The value of the discount.
 * @property {string} discount_value_type - The type of the discount, either "FIXED" or "PERCENTAGE".
 */

/**
 * Calculates the total discount percentage from an array of discount objects.
 * Fixed discount values are converted into percentages based on the base price.
 *
 * @param {AddonDiscount[]} discounts - The array of discount objects.
 * @param {number} basePrice - The base price to which fixed discounts are converted into percentages.
 * @returns {number} The total discount percentage.
 */
function calculateTotalAdnDiscount(discounts, basePrice) {
	let totalDiscountPercentage = 0;

	discounts.forEach((discount) => {
		if (discount.discount_value_type === "FIXED") {
			// Convert fixed discount to percentage
			const percentage = ((discount.discount_value * 100) / basePrice) * 100;
			totalDiscountPercentage += percentage;
		} else if (discount.discount_value_type === "PERCENTAGE") {
			totalDiscountPercentage += discount.discount_value;
		}
	});

	return totalDiscountPercentage;
}

/**
 * Returns sum of the saleprice and discount price for the given addon array
 * @param {any[]} addOns
 */
function getTotalAddonPrice(addOns) {
	// console.log(addOns, "addons");
	let totalSalePrice = 0;
	let totalDiscountPrice = 0;
	addOns.forEach((a) => {
		if (a.data.length) {
			if (a.data[0].price_info) {
				totalSalePrice += a.data[0].price_info.price;
				if (a.data[0].price_info[a.data[0].purchase_type].discount_price) {
					totalDiscountPrice += a.data[0].price_info[a.data[0].purchase_type].discount_price;
				}
			}
		}
	});
	return { totalSalePrice, totalDiscountPrice };
}

/**
 * This function updates the price and save labels according to the selected payment blocks
 * @param {object} headerBlock - price into state of the header block will be used to update the topline price
 * @param {string} blockType - block type of the current payment block
 */

function updateMainProductLinePrice(headerBlock, blockType) {
	const priceWrapEl = document.querySelector(".price-list.prive_price-list");
	const stickyPriceWrapEl = document.querySelector(".product-sticky-form__info .price-list");
	const saveLabelsWrapEl = document.querySelector(".product-meta__label-list.prive-label-list");
	priceWrapEl.innerHTML = "";
	saveLabelsWrapEl.innerHTML = "";

	if (priceWrapEl) {
		const priceElementSr = document.createElement("span");
		const salePriceElement = document.createElement("span");
		const priceElement = document.createElement("s");

		priceElementSr.classList.add("sr-only");
		priceElementSr.innerHTML = "Sale price";
		salePriceElement.classList.add("sale_price");
		salePriceElement.id = "price_element";

		priceWrapEl.appendChild(priceElementSr);

		let displayStrikethrough = false; // Flag to check if strikethrough should be displayed

		if (headerBlock.discount_price != null) {
			priceElement.setAttribute("style", "display:inline;");
			headerBlock.discount_price = (headerBlock.discount_price / 100).toFixed(2);
			salePriceElement.style.color = "var(--brand-red-secondary)";
			salePriceElement.innerHTML = formatMoneyy(headerBlock.discount_price);
			priceElement.innerHTML = formatMoneyy(headerBlock.sale_price);

			// Check if the priceElement and salePriceElement are different
			if (headerBlock.discount_price != headerBlock.sale_price) {
				displayStrikethrough = true; // Show strikethrough only when they differ
			}
		} else {
			priceElement.removeAttribute("style");
			salePriceElement.innerHTML = formatMoneyy(headerBlock.sale_price);
			priceElement.innerHTML = formatMoneyy(headerBlock.sale_price);
		}

		// Only append the strikethrough price if they are different
		if (displayStrikethrough) {
			priceWrapEl.appendChild(priceElement);
		}
		priceWrapEl.appendChild(salePriceElement);
	}

	if (saveLabelsWrapEl && headerBlock.savings && headerBlock.savings.length) {
		const savingsArr = Array.isArray(headerBlock.savings)
			? headerBlock.savings
			: [formatSavingsLabel(headerBlock.savings)];
		savingsArr.forEach((s, index) => {
			console.log("[savingsArr:s]", s);
			console.log("[savingsArr:index]", index);
			if (s && !s.includes('null')) {
				// hardcoded rounding for 67% sale
				if (s === "SAVE 66.68%") {
					s = "SAVE 67.00%";
				}
				const saveLblsavingsLblEl = `
				<span class="case-${index + 1}">
					<span dir="ltr" class="label label--highlight product-thumbnail_badge case-${index + 1}">
						<span>${s}</span>
					</span>
				</span>
				`;
				saveLabelsWrapEl.innerHTML += saveLblsavingsLblEl;
			}
		});
	}
}

/**
 * Generates a savings message based on the provided savings value.
 *
 * @param {number|string} savings - The savings value, which could be a percentage or a dollar amount.
 * @returns {string|null} The savings message if savings is provided and greater than 0, otherwise null.
 */
function formatSavingsLabel(savings) {
	if (!savings) return null;
	if (!isNaN(savings)) savings = savings.toFixed();
	const savingsStr = savings.toString().trim();
	const hasPercentageOrDollar = /[%$]/.test(savingsStr);
	return hasPercentageOrDollar ? `${savingsStr} OFF` : `${parseInt(savingsStr)}% OFF`;
}

/**
 * Generates a savings label for addons along with main product.
 *
 * @param {string[]} labelArr - reff of current savings label array.
 * @param {any[]} addonBlockArr - reff of currently active addon block array
 * @returns {string[]} - modified savings label array with newly added labels.
 */
function getSavingsLabelForAddons(labelArr = [], addonBlockArr = []) {
	addonBlockArr.forEach((block) => {
		if (block.data[0]) {
			const selectedPurchaseType = block.data[0].purchase_type;
			const productTitle = block.data[0].variant_title;
			const discountValue = block.data[0].price_info
				? block.data[0].price_info[selectedPurchaseType].discount_percentage
				: 0;
			if (discountValue) {
				labelArr.push(`${parseInt(discountValue)}% OFF ${productTitle}`);
			}
		}
	});

	return labelArr;
}

/**
 * Gets the additional promo labels or secondary price line from addon blocks
 * @param {string[]} labelArr - reff of current savings label array.
 * @param {any[]} addonBlockArr - reff of currently active addon block array
 * @param {object} blockData - reff of current blockdata object
 * @returns {string[]} - modified savings label array with newly added labels.
 */
function renderAdditionalPromoLabelOrPrice(labelArr = [], addonBlockArr = [], blockData) {
	addonBlockArr.forEach((block) => {
		const currentSelectedBlockData = blockData.add_ons.find((b) => b.id === block.id);
		let additionalPromoTag = currentSelectedBlockData.additional_promo_save_tag || null;
		const defaultPurchaseType = currentSelectedBlockData.default_purchase_type;
		if (block.data[0]) {
			const currentAddon = block.data[0];
			const selectedPurchaseType = currentAddon.purchase_type;
			if (additionalPromoTag && selectedPurchaseType != defaultPurchaseType) {
				if (!currentSelectedBlockData?.render_promo_tag_as || currentSelectedBlockData.render_promo_tag_as === "LABEL") {
					labelArr.push(additionalPromoTag);
				} else if (currentSelectedBlockData.render_promo_tag_as === "PRICE_LINE") {
					clearSecondaryPriceLine();
					let discountValue = parseFloat(currentSelectedBlockData.subscription_discount_value);

					if (defaultPurchaseType === "ONE_TIME") {
						discountValue = parseFloat(currentSelectedBlockData.one_time_discount_value);
					}
					let mainProductMSRP = window.mainProductPrice.sale_price;
					let salePrice = calculateDiscountedPrice(mainProductMSRP, discountValue);
					let mainPriceLineEl = document.querySelector(".prive_product-meta__price-list-container");
					let secondaryPriceLineEl = document.createElement("div");
					secondaryPriceLineEl.classList.add("secondary-price");
					secondaryPriceLineEl.setAttribute("id", "secondaryPriceLine");
					let priceElStr = ``;

					if (
						blockData.price_render_mode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT" ||
						blockData.price_render_mode === "DISPLAY_COMBINED_PRICE"
					) {
						let addOnMsrpPrice = currentAddon.price_info.price;
						let addOnSalePrice = currentAddon.price_info[defaultPurchaseType].discount_price;
						mainProductMSRP += addOnMsrpPrice;
						salePrice += addOnSalePrice;
						discountValue = calculateDiscountPercentage(mainProductMSRP, salePrice);
					}

					if (mainProductMSRP) {
						priceElStr += `<span class="secondary-price__msrp-price ${salePrice ? "has-sale" : ""}">${formatMoneyy(
							mainProductMSRP
						)}</span>`;
					}
					if (salePrice) {
						priceElStr += `<span class="secondary-price__sale-price">${formatMoneyy(salePrice)}</span>`;
					}

					additionalPromoTag = additionalPromoTag.replace("${price}", priceElStr);

					if (discountValue) {
						const discountTagEl = `<span class="label label--highlight product-thumbnail_badge case-1">SAVE ${parseInt(discountValue)}%</span>`;
						additionalPromoTag = additionalPromoTag.replace("${discount_per}", discountTagEl);
					} else {
						additionalPromoTag = additionalPromoTag.replace("${discount_per}", '');
					}

					secondaryPriceLineEl.innerHTML = additionalPromoTag;

					if (mainPriceLineEl) {
						mainPriceLineEl.insertAdjacentElement("afterend", secondaryPriceLineEl);
					}
				}
			} else {
				clearSecondaryPriceLine();
			}
		}
	});
	return labelArr;
}

/**
 * Renders the additional tag on the initial mount cycle from the 1st available pay in full block
 * @param {any[]} blocks - reff of payment blocks array
 * @returns {void}
 */
function renderAdditionalTagOrPriceOnMount(blocks) {
	const saveLabelsWrapEl = document.querySelector(".product-meta__label-list.prive-label-list");
	const firstPayInFullBlock = blocks.find((b) => b.type === "pay_in_full");
	if (!firstPayInFullBlock) return;
	firstPayInFullBlock.add_ons.forEach((a) => {
		const defaultPurchaseType = a.default_purchase_type;
		let additionalPromoTag = a?.additional_promo_save_tag;
		let discountValue = parseFloat(a.subscription_discount_value);
		//console.log(defaultPurchaseType, "default purchase type");
		if (defaultPurchaseType === "ONE_TIME") {
			discountValue = parseFloat(a.one_time_discount_value);
		}
		//console.log(a?.render_promo_tag_as, additionalPromoTag,"asdasdasdasdasdasdsa");
		if (a?.render_promo_tag_as === "LABEL" && additionalPromoTag) {
			if (additionalPromoTag && discountValue) {
				const savingsLblEl = document.createElement("span");
				savingsLblEl.classList.add("label", "label--highlight");
				savingsLblEl.innerHTML = additionalPromoTag;
				saveLabelsWrapEl.appendChild(savingsLblEl);
			}
		} else if (a?.render_promo_tag_as === "PRICE_LINE" && additionalPromoTag) {
			clearSecondaryPriceLine();
			let mainProductMSRP = window.mainProductPrice.sale_price;
			let salePrice = calculateDiscountedPrice(mainProductMSRP, discountValue);
			let mainPriceLineEl = document.querySelector(".prive_product-meta__price-list-container");
			let secondaryPriceLineEl = document.createElement("div");
			secondaryPriceLineEl.classList.add("secondary-price");
			secondaryPriceLineEl.setAttribute("id", "secondaryPriceLine");
			let priceElStr = ``;

			if (mainProductMSRP) {
				priceElStr += `<span class="secondary-price__msrp-price ${salePrice ? "has-sale" : ""}">${formatMoneyy(
					mainProductMSRP
				)}</span>`;
			}
			if (salePrice) {
				priceElStr += `<span class="secondary-price__sale-price">${formatMoneyy(salePrice)}</span>`;
			}

			additionalPromoTag = additionalPromoTag.replace("${price}", priceElStr);

			if (discountValue) {
				const discountTagEl = `<span class="label label--highlight product-thumbnail_badge case-1">SAVE ${parseInt(discountValue)}%</span>`;
				additionalPromoTag = additionalPromoTag.replace("${discount_per}", discountTagEl);
			} else {
				additionalPromoTag = additionalPromoTag.replace("${discount_per}", '');
			}

			secondaryPriceLineEl.innerHTML = additionalPromoTag;

			if (mainPriceLineEl) {
				mainPriceLineEl.insertAdjacentElement("afterend", secondaryPriceLineEl);
			}
		}
	});
}

function clearSecondaryPriceLine() {
	const existingSecondaryPriceLineEl = document.querySelector("#secondaryPriceLine");
	if (existingSecondaryPriceLineEl) {
		existingSecondaryPriceLineEl.remove();
	}
}

/**
 * Calculates the discount percentage based on the sale price and offer price.
 *
 * @param {number} salePrice - The original sale price of the item.
 * @param {number} offerPrice - The discounted offer price of the item.
 * @returns {number|null} - The integer part of the discount value, or null if inputs are invalid.
 */
function calculateDiscountPercentage(salePrice, offerPrice) {
	if (
		typeof salePrice !== "number" ||
		typeof offerPrice !== "number" ||
		salePrice <= 0 ||
		offerPrice < 0 ||
		offerPrice > salePrice
	) {
		return null;
	}
	const discount = ((salePrice - offerPrice) / salePrice) * 100;
	return Math.round(discount);
}

/**
 * Compares the user location with blacklist and returns false if the location is part of the black list
 * @param {string[]} blacklist
 * @returns {boolean}
 */
function shouldRenderBlock(blacklist = []) {
	// console.log({ urlHostname, countryDomainMap, blacklist });
	if (urlHostname !== "www.hotelcollection.com" && blacklist.includes("International")) {
		return false;
	} else if (countryDomainMap && blacklist.includes(countryDomainMap.country)) {
		return false;
	}

	if (!countryDomainMap && currentGeolocation) {
		//console.log("currentGeolocation");
		if (currentGeolocation.country_name != "United States" && blacklist.includes("International")) {
			return false;
		} else if (blacklist.includes(currentGeolocation.country_name)) {
			return false;
		}
	}

	return true;
}

function tabbyAndTamara(price) {
	new TabbyPromo({
		selector: '#TabbyPromo', // required, content of tabby Promo Snippet will be placed in element with that selector.
		currency: 'SAR', // required, AED|SAR|KWD only supported, with no spaces or lowercase.
		price: `${price / 100}`, // required, price of the product. 2 decimals max for AED|SAR and 3 decimals max for KWD.
		lang: window.Shopify.locale, // Optional, en|ar only supported
		source: 'product', // Optional, snippet placement; `product` for product page and `cart` for cart page.
		publicKey: 'pk_01933f35-7667-932a-c366-87c746edb6db', // required, Public Key
		merchantCode: 'string'  // required
	});

	document.querySelectorAll("tamara-widget[type='tamara-summary']").forEach(el => el.remove());
	const tamaraWidget = document.createElement("tamara-widget");
	tamaraWidget.setAttribute("type", "tamara-summary");
	tamaraWidget.setAttribute("amount", `${price / 100}`);
	tamaraWidget.setAttribute("inline-type", "2");
	tamaraWidget.setAttribute("inline-variant", "text");
	tamaraWidget.setAttribute("config", '{"badgePosition":"right","showExtraContent":"","hidePayInX":false}');

	const tabbyPromo = document.getElementById("TabbyPromo");
	if (tabbyPromo && tabbyPromo.parentNode) {
		tabbyPromo.parentNode.insertBefore(tamaraWidget, tabbyPromo.nextSibling);
	}
}